console.log("YAY SOMETHING")
const Ct = "modulepreload",
    xt = function (s, t) {
        return new URL(s, t).href;
    },
    ot = {},
    Tt = function (t, e, i) {
        let n = Promise.resolve();
        if (e && e.length > 0) {
            let c = function (d) {
                return Promise.all(
                    d.map((u) =>
                        Promise.resolve(u).then(
                            (f) => ({ status: "fulfilled", value: f }),
                            (f) => ({ status: "rejected", reason: f })
                        )
                    )
                );
            };
            const o = document.getElementsByTagName("link"),
                a = document.querySelector("meta[property=csp-nonce]"),
                l = a?.nonce || a?.getAttribute("nonce");
            n = c(
                e.map((d) => {
                    if (((d = xt(d, i)), d in ot)) return;
                    ot[d] = !0;
                    const u = d.endsWith(".css"),
                        f = u ? '[rel="stylesheet"]' : "";
                    if (i)
                        for (let p = o.length - 1; p >= 0; p--) {
                            const v = o[p];
                            if (v.href === d && (!u || v.rel === "stylesheet")) return;
                        }
                    else if (document.querySelector(`link[href="${d}"]${f}`)) return;
                    const m = document.createElement("link");
                    if (
                        ((m.rel = u ? "stylesheet" : Ct),
                        u || (m.as = "script"),
                        (m.crossOrigin = ""),
                        (m.href = d),
                        l && m.setAttribute("nonce", l),
                        document.head.appendChild(m),
                        u)
                    )
                        return new Promise((p, v) => {
                            m.addEventListener("load", p),
                                m.addEventListener("error", () => v(new Error(`Unable to preload CSS for ${d}`)));
                        });
                })
            );
        }
        function r(o) {
            const a = new Event("vite:preloadError", { cancelable: !0 });
            if (((a.payload = o), window.dispatchEvent(a), !a.defaultPrevented)) throw o;
        }
        return n.then((o) => {
            for (const a of o || []) a.status === "rejected" && r(a.reason);
            return t().catch(r);
        });
    };
function B(s) {
    for (var t = 1; t < arguments.length; t++) {
        var e = arguments[t];
        for (var i in e) s[i] = e[i];
    }
    return s;
}
var At = {
    read: function (s) {
        return s[0] === '"' && (s = s.slice(1, -1)), s.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function (s) {
        return encodeURIComponent(s).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    },
};
function K(s, t) {
    function e(n, r, o) {
        if (!(typeof document > "u")) {
            (o = B({}, t, o)),
                typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)),
                o.expires && (o.expires = o.expires.toUTCString()),
                (n = encodeURIComponent(n)
                    .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
                    .replace(/[()]/g, escape));
            var a = "";
            for (var l in o) o[l] && ((a += "; " + l), o[l] !== !0 && (a += "=" + o[l].split(";")[0]));
            return (document.cookie = n + "=" + s.write(r, n) + a);
        }
    }
    function i(n) {
        if (!(typeof document > "u" || (arguments.length && !n))) {
            for (var r = document.cookie ? document.cookie.split("; ") : [], o = {}, a = 0; a < r.length; a++) {
                var l = r[a].split("="),
                    c = l.slice(1).join("=");
                try {
                    var d = decodeURIComponent(l[0]);
                    if (((o[d] = s.read(c, d)), n === d)) break;
                } catch {}
            }
            return n ? o[n] : o;
        }
    }
    return Object.create(
        {
            set: e,
            get: i,
            remove: function (n, r) {
                e(n, "", B({}, r, { expires: -1 }));
            },
            withAttributes: function (n) {
                return K(this.converter, B({}, this.attributes, n));
            },
            withConverter: function (n) {
                return K(B({}, this.converter, n), this.attributes);
            },
        },
        { attributes: { value: Object.freeze(t) }, converter: { value: Object.freeze(s) } }
    );
}
K(At, { path: "/" });
const Y = [];
let X = !1;
function vt(s) {
    if (X || window.theme?.pubsub) {
        (X = !0), s();
        return;
    }
    Y.push(s);
}
function Ue() {
    const s = () => {
        window.theme?.pubsub && ((X = !0), Y.forEach((e) => e()), (Y.length = 0));
    };
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", s, { once: !0 }) : s();
}
const W = { prefix: "font-weight: bold;", success: "color: #22c55e;", error: "color: #ef4444;" },
    h = (s, t = "info", e) => {
        if (window.STOREFRONT?.settings?.devMode) {
            const i = "%c[STOREFRONT]%c",
                r = t === "error" ? W.error : W.success,
                o = `${W.prefix} ${r}`,
                a = [i, o, r, s, ...(e !== void 0 ? [e] : [])];
            switch (t) {
                case "info":
                    console.info(...a);
                    break;
                case "warn":
                    console.warn(...a);
                    break;
                case "error":
                    console.error(...a);
                    break;
            }
        }
    },
    R = (s) => {
        h(`${s.name}: ${s.value.toFixed(2)}`, "info", s);
    },
    je = () => {
        Tt(() => import("./web-vitals-D8cA-W4R.js"), [], import.meta.url)
            .then((s) => {
                s.onCLS && s.onCLS(R),
                    s.onINP && s.onINP(R),
                    s.onFCP && s.onFCP(R),
                    s.onLCP && s.onLCP(R),
                    s.onTTFB && s.onTTFB(R);
            })
            .catch(() => {
                h("Web Vitals not available", "warn");
            });
    },
    We = () => {
        window.STOREFRONT?.events &&
            window.STOREFRONT.events.addEventListener("theme:loaded", () => {
                h("Theme loaded event fired", "info");
            }),
            document.addEventListener("cart:updated", (s) => {
                h("Cart updated", "info", s.detail);
            }),
            document.addEventListener("section:loaded", (s) => {
                h("Section loaded", "info", s.detail);
            });
    },
    it = (s) => {
        const t = window;
        let e = null;
        const i = () => {
            t.theme?.pubsub &&
                !e &&
                ((e = t.theme.pubsub.subscribe(t.theme.pubsub.PUB_SUB_EVENTS.variantChange, (n) => {
                    const o = { detail: { variant: n?.data?.variant }, type: "variant:change" };
                    try {
                        s(o);
                    } catch (a) {
                        h("Variant change callback error", "error", a);
                    }
                })),
                h("useVariantChange: Subscribed via pubsub", "info"));
        };
        return (
            t.theme?.pubsub ? i() : document.addEventListener("page:loaded", i, { once: !0 }),
            {
                unsubscribe: () => {
                    e && (e(), (e = null));
                },
            }
        );
    };
class C {
    constructor(t, e = {}) {
        if (((this._isDestroyed = !1), !t)) throw new Error("Container element is required");
        (this.container = t),
            (this.config = { ...this.getDefaultConfig(), ...e }),
            window.queueMicrotask(() => this.init());
    }
    log(t, e = "info") {
        this.config.debug && h(`[${this.componentName}] ${t}`, e);
    }
    isDestroyed() {
        return this._isDestroyed;
    }
    checkDestroyed() {
        return this._isDestroyed ? (this.log("Component already destroyed", "warn"), !0) : !1;
    }
    destroy() {
        this._isDestroyed || ((this._isDestroyed = !0), this.log("Component destroyed"));
    }
}
function k(s, t) {
    let e = null;
    return (...i) => {
        e && window.clearTimeout(e),
            (e = window.setTimeout(() => {
                s(...i);
            }, t));
    };
}
function L(s, t) {
    const e = {};
    for (const [i, n] of Object.entries(t)) e[i] = s.querySelector(n);
    return e;
}
function y(s, t) {
    return s ? !0 : (t && h(t, "warn"), !1);
}
const nt = { xs: 320, sm: 640, md: 768, lg: 1024, xl: 1280 },
    bt = { normal: 300 };
class Lt extends C {
    constructor(t, e = {}) {
        super(t, e),
            (this.componentName = "Collage"),
            (this.slides = []),
            (this.currentSlide = 0),
            (this.totalSlides = 0);
    }
    getDefaultConfig() {
        return { mobileCarousel: !0, mobileContentHover: !1, autoplay: !1, animationDuration: bt.normal, debug: !1 };
    }
    init() {
        this.cacheElementsAndSetup() &&
            ((this.boundScrollHandler = k(this.handleScroll.bind(this), 50)),
            this.setupSlide(),
            this.bindEvents(),
            this.updateCounter(),
            this.log("Component initialized"));
    }
    cacheElementsAndSetup() {
        return (
            (this.elements = L(this.container, {
                slideContainer: "[data-slide-container]",
                slides: ".collage__slide",
                counterCurrent: "[data-counter-current]",
                counterTotal: "[data-counter-total]",
            })),
            y(this.elements.slideContainer, "[Collage] Slide container not found")
                ? ((this.slides = Array.from(this.container.querySelectorAll(".collage__slide"))),
                  (this.totalSlides = this.slides.length),
                  this.totalSlides === 0 ? (this.log("No slides found", "warn"), !1) : !0)
                : !1
        );
    }
    setupSlide() {
        this.elements.slideContainer &&
            (this.elements.slideContainer.addEventListener("scroll", this.boundScrollHandler),
            this.updateSlideVisibility());
    }
    bindEvents() {}
    handleScroll() {
        this.updateCurrentSlide(), this.updateCounter();
    }
    updateCurrentSlide() {
        if (!this.elements.slideContainer || this.slides.length === 0) return;
        const t = this.elements.slideContainer.getBoundingClientRect(),
            e = t.left + t.width / 2;
        let i = 0,
            n = 1 / 0;
        this.slides.forEach((r, o) => {
            const a = r.getBoundingClientRect(),
                l = a.left + a.width / 2,
                c = Math.abs(l - e);
            c < n && ((n = c), (i = o));
        }),
            i !== this.currentSlide && ((this.currentSlide = i), this.updateSlideVisibility());
    }
    updateSlideVisibility() {
        this.slides.forEach((t, e) => {
            t.classList.toggle("is-active", e === this.currentSlide);
        });
    }
    updateCounter() {
        this.elements.counterCurrent && (this.elements.counterCurrent.textContent = (this.currentSlide + 1).toString()),
            this.elements.counterTotal && (this.elements.counterTotal.textContent = this.totalSlides.toString());
    }
    goToSlide(t) {
        if (t < 0 || t >= this.totalSlides || !this.elements.slideContainer) return;
        const e = this.slides[t];
        if (!e) return;
        const i = this.elements.slideContainer.getBoundingClientRect(),
            r = e.getBoundingClientRect().left - i.left + this.elements.slideContainer.scrollLeft;
        this.elements.slideContainer.scrollTo({ left: r, behavior: "smooth" }),
            (this.currentSlide = t),
            this.updateSlideVisibility(),
            this.updateCounter();
    }
    getCurrentSlide() {
        return this.currentSlide;
    }
    destroy() {
        this.isDestroyed() ||
            (this.elements.slideContainer &&
                this.elements.slideContainer.removeEventListener("scroll", this.boundScrollHandler),
            super.destroy(),
            this.log("Component destroyed"));
    }
}
const A = (s, t) => (t === 1 ? s.option1 : t === 2 ? s.option2 : t === 3 ? s.option3 : null),
    O = (s) =>
        s
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;"),
    D = new Map();
class kt extends HTMLElement {
    constructor() {
        super(),
            (this.isLoading = !1),
            (this.selectedVariants = new Map()),
            (this.products = []),
            (this.productId = this.dataset.productId || ""),
            (this.limit = parseInt(this.dataset.limit || "4", 10)),
            this.init();
    }
    init() {
        if (!this.productId) {
            h("ProductRecommendations: Missing product ID", "error");
            return;
        }
        this.loadRecommendations();
    }
    async loadRecommendations() {
        if (this.isLoading) return;
        const t = `${this.productId}-${this.limit}`,
            e = D.get(t);
        if (e) {
            (this.products = e),
                this.renderRecommendations(this.products),
                this.dispatchEvent(
                    new CustomEvent("recommendations:loaded", {
                        bubbles: !0,
                        detail: { productId: this.productId, count: this.products.length, fromCache: !0 },
                    })
                ),
                h(`ProductRecommendations: Using cached ${this.products.length} recommendations`, "info");
            return;
        }
        (this.isLoading = !0), this.showLoadingState();
        try {
            const i = `/recommendations/products.json?product_id=${this.productId}&limit=${this.limit}`,
                n = await fetch(i);
            if (!n.ok) throw new Error(`HTTP ${n.status}`);
            const r = await n.json();
            (this.products = r.products || []),
                D.set(t, this.products),
                this.renderRecommendations(this.products),
                this.dispatchEvent(
                    new CustomEvent("recommendations:loaded", {
                        bubbles: !0,
                        detail: { productId: this.productId, count: r.products?.length || 0 },
                    })
                ),
                h(`ProductRecommendations: Loaded ${r.products?.length || 0} recommendations`, "info");
        } catch (i) {
            this.showErrorState();
            const n = i instanceof Error ? i.message : String(i);
            this.dispatchEvent(
                new CustomEvent("recommendations:error", {
                    bubbles: !0,
                    detail: { productId: this.productId, error: n },
                })
            ),
                h(`ProductRecommendations: Error - ${n}`, "error");
        } finally {
            this.isLoading = !1;
        }
    }
    showLoadingState() {
        this.innerHTML = `
      <span class="horizontal-product__skeleton"></span>
      <span class="horizontal-product__skeleton"></span>
    `;
    }
    showErrorState() {
        this.innerHTML = `
      <div class="product-recommendations-error text-center py-4">
        <p class="text-sm text-opacity">Unable to load recommendations.</p>
      </div>
    `;
    }
    renderRecommendations(t) {
        if (!t.length) {
            this.innerHTML = "";
            return;
        }
        t.forEach((i) => {
            if (i.variants && i.variants.length > 0) {
                const n = i.variants.find((r) => r.available) || i.variants[0];
                this.selectedVariants.set(i.id, n.id);
            }
        });
        const e = t.map((i) => this.renderProduct(i)).join("");
        (this.innerHTML = e), this.setupVariantListeners();
    }
    renderProduct(t) {
        const e = this.selectedVariants.get(t.id),
            i = t.variants?.find((l) => l.id === e) || t.variants?.[0];
        if (!i) return "";
        const n = i.featured_image || t.featured_image,
            r = t.variants && t.variants.length > 1,
            o = this.closest("[data-section-id]")?.getAttribute("data-section-id") || "",
            a = i.compare_at_price && i.compare_at_price > i.price;
        return `
      <div class="bundle-recommendation-item" data-product-id="${t.id}">
        <label class="product-bundle__info flex items-center gap-4 md:gap-6" for="Recommendations-${o}-${t.id}">
          <input
            name="bundles"
            value="${i.id}"
            data-price="${i.price}"
            data-product-id="${t.id}"
            class="checkbox bundle-checkbox"
            id="Recommendations-${o}-${t.id}"
            type="checkbox"
            ${i.available ? "" : "disabled"}
          />
          ${
              n
                  ? `
            <picture class="horizontal-product__media media media--square relative overflow-hidden shrink-0 pointer-events-none">
              <img
                src="${n.src || n}"
                alt="${n.alt || t.title}"
                loading="lazy"
                class="object-cover w-full h-full bundle-product-image"
                data-product-id="${t.id}"
              />
            </picture>
          `
                  : ""
          }
          <div class="horizontal-product__details flex flex-col justify-start gap-1d5">
            <div class="flex flex-col gap-1">
              <p class="horizontal-product__title font-medium text-base leading-tight">
                ${t.title}
              </p>
            </div>
          </div>
          <div class="horizontal-product__quantity shrink-0">
            <span class="bundle-product-price" data-product-id="${t.id}">
              ${
                  i.available
                      ? `
                <div class="flex flex-col items-end gap-0d5">
                  <span class="price font-medium">${this.formatPrice(i.price)}</span>
                  ${
                      a && i.compare_at_price
                          ? `
                    <span class="price-compare text-xs text-opacity" style="text-decoration: line-through;">${this.formatPrice(i.compare_at_price)}</span>
                  `
                          : ""
                  }
                </div>
              `
                      : `
                <span class="text-sm-base text-opacity">Sold out</span>
              `
              }
            </span>
          </div>
        </label>
        ${r ? this.renderVariantSelector(t, i) : ""}
      </div>
    `;
    }
    renderVariantSelector(t, e) {
        if (!t.variants || t.variants.length <= 1) return "";
        const i = t.options || [];
        return `
      <div class="bundle-variant-selector" data-product-id="${t.id}" style="display: none;">
        ${i
            .map((n, r) => {
                const o = r + 1,
                    a = A(e, o);
                return `
            <div class="variant-option-group">
              <label class="variant-option-label text-xs text-opacity">${n.name}</label>
              <div class="variant-option-values">
                ${n.values
                    .map((l) => {
                        const c = this.isOptionValueAvailable(t, r, l, e),
                            d = l === a;
                        return c
                            ? `
                    <button
                      type="button"
                      class="variant-option-button ${d ? "selected" : ""}"
                      data-product-id="${t.id}"
                      data-option-position="${o}"
                      data-option-value="${O(l)}"
                      aria-label="${O(n.name)}: ${O(l)}"
                    >
                      ${O(l)}
                    </button>
                  `
                            : "";
                    })
                    .join("")}
              </div>
            </div>
          `;
            })
            .join("")}
      </div>
    `;
    }
    isOptionValueAvailable(t, e, i, n) {
        const r = e + 1;
        return t.variants.some((o) => A(o, r) === i && o.available);
    }
    setupVariantListeners() {
        this.addEventListener("change", (t) => {
            const e = t.target;
            if (e.classList.contains("bundle-checkbox")) {
                const i = parseInt(e.dataset.productId || "0", 10);
                this.toggleVariantSelector(i, e.checked);
            }
        }),
            this.addEventListener("click", (t) => {
                const i = t.target.closest(".variant-option-button");
                if (!i || i.hasAttribute("disabled")) return;
                const n = parseInt(i.getAttribute("data-product-id") || "0", 10),
                    r = parseInt(i.getAttribute("data-option-position") || "0", 10),
                    o = i.getAttribute("data-option-value") || "";
                n && r && o && this.handleVariantChange(n, r, o);
            });
    }
    toggleVariantSelector(t, e) {
        const i = this.querySelector(`.bundle-recommendation-item[data-product-id="${t}"]`);
        if (!i) return;
        const n = i.querySelector(".bundle-variant-selector");
        n &&
            (e
                ? ((n.style.display = "flex"),
                  window.setTimeout(() => {
                      n.classList.add("is-visible");
                  }, 10))
                : (n.classList.remove("is-visible"),
                  window.setTimeout(() => {
                      n.style.display = "none";
                  }, 300)));
    }
    handleVariantChange(t, e, i) {
        const n = this.products.find((l) => l.id === t);
        if (!n || !n.variants) {
            h(`ProductRecommendations: Product ${t} not found`, "warn");
            return;
        }
        const r = this.selectedVariants.get(t),
            o = n.variants.find((l) => l.id === r),
            a = this.findMatchingVariant(n, e, i, o);
        a
            ? this.updateVariantSelection(t, a)
            : h(`ProductRecommendations: No available variant found for option ${e}="${i}"`, "warn");
    }
    findMatchingVariant(t, e, i, n) {
        const r = {};
        if (n)
            for (let a = 1; a <= 3; a++) {
                const l = A(n, a);
                l && (r[a] = l);
            }
        r[e] = i;
        const o = t.variants.find((a) => {
            if (!a.available) return !1;
            for (const l in r) if (A(a, Number(l)) !== r[Number(l)]) return !1;
            return !0;
        });
        return o || t.variants.find((a) => A(a, e) === i && a.available);
    }
    updateVariantSelection(t, e) {
        this.selectedVariants.set(t, e.id);
        const i = this.querySelector(`.bundle-recommendation-item[data-product-id="${t}"]`);
        if (!i) return;
        const n = i.querySelector(".bundle-checkbox");
        if (
            (n && ((n.value = String(e.id)), (n.dataset.price = String(e.price)), (n.disabled = !e.available)),
            e.featured_image)
        ) {
            const l = i.querySelector(".bundle-product-image");
            l && ((l.src = e.featured_image.src), (l.alt = e.featured_image.alt || e.title));
        }
        const r = i.querySelector(".bundle-product-price");
        if (r) {
            const l = e.compare_at_price && e.compare_at_price > e.price;
            r.innerHTML = e.available
                ? `<div class="flex flex-col items-end gap-0d5">
            <span class="price font-medium">${this.formatPrice(e.price)}</span>
            ${
                l && e.compare_at_price
                    ? `
              <span class="price-compare text-xs text-opacity" style="text-decoration: line-through;">${this.formatPrice(e.compare_at_price)}</span>
            `
                    : ""
            }
          </div>`
                : '<span class="text-sm-base text-opacity">Sold out</span>';
        }
        const o = i.querySelectorAll(".variant-option-button"),
            a = this.products.find((l) => l.id === t);
        if (!a) {
            h(`ProductRecommendations: Product ${t} not found in products array`, "warn");
            return;
        }
        o.forEach((l) => {
            const c = parseInt(l.getAttribute("data-product-id") || "0", 10),
                d = parseInt(l.getAttribute("data-option-position") || "0", 10),
                u = l.getAttribute("data-option-value") || "";
            c === t &&
                (A(e, d) === u ? l.classList.add("selected") : l.classList.remove("selected"),
                a.variants.some((p) => p.available && A(p, d) === u)
                    ? (l.removeAttribute("disabled"), l.classList.remove("is-unavailable"))
                    : (l.setAttribute("disabled", ""), l.classList.add("is-unavailable")));
        }),
            h(`Variant updated for product ${t}: ${e.title} (${e.id})`, "info");
    }
    formatPrice(t) {
        return `£${(t / 100).toFixed(2)}`;
    }
    refresh() {
        if (!this.isLoading) {
            const t = `${this.productId}-${this.limit}`;
            D.delete(t), this.loadRecommendations();
        }
    }
    static clearCache() {
        D.clear();
    }
    destroy() {
        this.innerHTML = "";
    }
}
window.customElements.get("bundle-recommendations") || window.customElements.define("bundle-recommendations", kt);
class It extends HTMLElement {
    constructor() {
        super(...arguments),
            (this.config = null),
            (this.isExpanded = !1),
            (this.triggerButton = null),
            (this.comparisonContent = null),
            (this.selectedVariantName = ""),
            (this.variantSubscription = null);
    }
    connectedCallback() {
        this.parseConfig(),
            this.config && (this.getSelectedVariant(), this.render(), this.bindEvents(), this.setupVariantListener());
    }
    getSelectedVariant() {
        const t = document.querySelector('variant-picker input[type="radio"]:checked');
        t && (this.selectedVariantName = t.value);
    }
    getVariantImage(t) {
        const e = document.querySelector(`variant-picker input[type="radio"][value="${t}" i]`);
        if (e) {
            const n = e.parentElement
                ?.querySelector("label")
                ?.style.getPropertyValue("--swatch-background-image")
                ?.match(/url\(["']?([^"')]+)["']?\)/)?.[1];
            if (n) return n;
        }
        return this.config?.variants.find((i) => i.name.toLowerCase() === t.toLowerCase())?.image || "";
    }
    parseConfig() {
        const t = this.querySelector('script[type="application/json"]');
        if (t?.textContent)
            try {
                this.config = JSON.parse(t.textContent);
            } catch (e) {
                h("Failed to parse variant comparison config", "error", e);
            }
    }
    render() {
        if (!this.config) return;
        const t =
                this.config.variants.find((i) => i.name.toLowerCase() === this.selectedVariantName.toLowerCase()) ||
                this.config.variants[0],
            e = this.getVariantImage(this.selectedVariantName) || t.image;
        (this.innerHTML = `
      <div class="variant-comparison">
        <button type="button" class="variant-comparison__trigger" aria-expanded="false" aria-controls="variant-comparison-content">
          <svg class="variant-comparison__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M8 4.5v7M8 11.5h.005" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <span>What's the difference?</span>
        </button>
        <div id="variant-comparison-content" class="variant-comparison__content" hidden>
          <div class="variant-comparison__cards">
            <div class="variant-comparison__card">
              <button type="button" class="variant-comparison__close" aria-label="Close comparison">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>
              <div class="variant-comparison__image">
                <img src="${e}" alt="${t.name}" loading="lazy" />
              </div>
              ${
                  t.badge.text
                      ? `<div class="variant-comparison__badge">
                ${this.getBadgeIcon(t.badge.icon)}
                <span>${t.badge.text}</span>
              </div>`
                      : ""
              }
              <p class="variant-comparison__description">${t.description}</p>
            </div>
          </div>
        </div>
      </div>
    `),
            (this.triggerButton = this.querySelector(".variant-comparison__trigger")),
            (this.comparisonContent = this.querySelector(".variant-comparison__content"));
    }
    getBadgeIcon(t) {
        const e = {
            heart: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 13.5s-5-3-5-7c0-2 1.5-3.5 3.5-3.5 1.5 0 2.5 1 3.5 2 1-1 2-2 3.5-2 2 0 3.5 1.5 3.5 3.5 0 4-5 7-5 7z" fill="currentColor"/></svg>',
            home: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 6l6-4 6 4v7a1 1 0 01-1 1H3a1 1 0 01-1-1V6z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        };
        return e[t] || e.heart;
    }
    bindEvents() {
        this.triggerButton?.addEventListener("click", this.handleToggle.bind(this)),
            this.querySelector(".variant-comparison__close")?.addEventListener("click", this.handleClose.bind(this));
    }
    setupVariantListener() {
        document.addEventListener("change", (t) => {
            const e = t.target;
            e &&
                e.matches('variant-picker input[type="radio"]') &&
                ((this.selectedVariantName = e.value),
                h("Variant changed via radio", "info", this.selectedVariantName),
                this.updateCard());
        }),
            (this.variantSubscription = it((t) => {
                const e = t.detail?.variant?.option1 || t.detail?.variant?.options?.[0];
                h("Variant changed via event", "info", { optionValue: e, detail: t.detail }),
                    e &&
                        ((this.selectedVariantName = e),
                        h("Selected variant name", "info", this.selectedVariantName),
                        this.updateCard());
            }));
    }
    updateCard() {
        if (!this.config) return;
        const t =
                this.config.variants.find((a) => a.name.toLowerCase() === this.selectedVariantName.toLowerCase()) ||
                this.config.variants[0],
            e = this.getVariantImage(this.selectedVariantName) || t.image,
            i = this.querySelector(".variant-comparison__card");
        if (!i) return;
        const n = i.querySelector(".variant-comparison__image img"),
            r = i.querySelector(".variant-comparison__badge"),
            o = i.querySelector(".variant-comparison__description");
        !n ||
            !o ||
            (i.classList.add("is-updating"),
            window.requestAnimationFrame(() => {
                window.setTimeout(() => {
                    if (((n.src = e), (n.alt = t.name), t.badge.text && r))
                        r.innerHTML = `
            ${this.getBadgeIcon(t.badge.icon)}
            <span>${t.badge.text}</span>
          `;
                    else if (t.badge.text && !r) {
                        const a = `<div class="variant-comparison__badge">
            ${this.getBadgeIcon(t.badge.icon)}
            <span>${t.badge.text}</span>
          </div>`;
                        n.parentElement?.insertAdjacentHTML("afterend", a);
                    } else !t.badge.text && r && r.remove();
                    (o.textContent = t.description),
                        window.requestAnimationFrame(() => {
                            window.requestAnimationFrame(() => {
                                i.classList.remove("is-updating");
                            });
                        });
                }, 200);
            }));
    }
    handleToggle() {
        this.isExpanded = !this.isExpanded;
        const t = this.querySelector(".variant-comparison");
        this.isExpanded
            ? (this.comparisonContent?.removeAttribute("hidden"),
              this.triggerButton?.setAttribute("aria-expanded", "true"),
              this.triggerButton?.setAttribute("hidden", ""),
              t?.classList.add("is-expanded"))
            : (this.comparisonContent?.setAttribute("hidden", ""),
              this.triggerButton?.setAttribute("aria-expanded", "false"),
              this.triggerButton?.removeAttribute("hidden"),
              t?.classList.remove("is-expanded"));
    }
    handleClose() {
        this.isExpanded = !1;
        const t = this.querySelector(".variant-comparison");
        this.comparisonContent?.setAttribute("hidden", ""),
            this.triggerButton?.setAttribute("aria-expanded", "false"),
            this.triggerButton?.removeAttribute("hidden"),
            t?.classList.remove("is-expanded");
    }
    disconnectedCallback() {
        this.variantSubscription?.unsubscribe();
    }
}
typeof window < "u" &&
    !window.customElements.get("variant-comparison") &&
    window.customElements.define("variant-comparison", It);
const at = "is-loading",
    Mt = 3e3;
class Rt extends HTMLElement {
    constructor() {
        super(...arguments),
            (this.variantSubscription = null),
            (this.currentOptions = new Map()),
            (this.mediaElements = []),
            (this.thumbnailElements = []),
            (this.sliderElement = null),
            (this.loadingTimeout = null),
            (this.pendingImages = new Set());
    }
    connectedCallback() {
        this.cacheElements(),
            this.parseInitialVariant(),
            this.setupVariantListener(),
            h("MediaGalleryFilter initialized", "info", {
                mediaCount: this.mediaElements.length,
                thumbnailCount: this.thumbnailElements.length,
            });
    }
    cacheElements() {
        this.querySelectorAll("[data-gang-options]").forEach((i) => {
            const n = i.dataset.gangOptions,
                r = i.dataset.gangConnects;
            n &&
                r &&
                this.mediaElements.push({
                    element: i,
                    optionNames: n.split(",").map((o) => o.trim()),
                    connects: r.split(",").map((o) => o.trim()),
                });
        }),
            this.querySelectorAll("button[data-gang-options]").forEach((i) => {
                const n = i.dataset.gangOptions,
                    r = i.dataset.gangConnects;
                n &&
                    r &&
                    this.thumbnailElements.push({
                        element: i,
                        optionNames: n.split(",").map((o) => o.trim()),
                        connects: r.split(",").map((o) => o.trim()),
                    });
            }),
            (this.sliderElement = this.querySelector("slider-element"));
    }
    parseInitialVariant() {
        document.querySelectorAll('variant-picker input[type="radio"]:checked').forEach((e) => {
            const n = e.closest("fieldset")?.querySelector("legend");
            if (n) {
                const r = this.handleize(n.textContent?.trim() || ""),
                    o = this.handleize(e.value);
                this.currentOptions.set(r, o);
            }
        }),
            h("Initial variant options", "info", Object.fromEntries(this.currentOptions));
    }
    setupVariantListener() {
        document.addEventListener("change", this.handleRadioChange.bind(this)),
            (this.variantSubscription = it((t) => {
                const e = t.detail?.variant;
                e &&
                    e.options &&
                    (document.querySelectorAll("variant-picker fieldset").forEach((n, r) => {
                        const o = n.querySelector("legend");
                        if (o && e.options && e.options[r]) {
                            const a = this.handleize(o.textContent?.trim() || ""),
                                l = this.handleize(e.options[r]);
                            this.currentOptions.set(a, l);
                        }
                    }),
                    this.updateMediaVisibility());
            }));
    }
    handleRadioChange(t) {
        const e = t.target;
        if (!e?.matches('variant-picker input[type="radio"]')) return;
        const n = e.closest("fieldset")?.querySelector("legend");
        if (!n) return;
        const r = this.handleize(n.textContent?.trim() || ""),
            o = this.handleize(e.value);
        this.currentOptions.set(r, o),
            h("Option changed", "info", { optionName: r, value: o }),
            this.updateMediaVisibility();
    }
    updateMediaVisibility() {
        let t = 0,
            e = 0;
        const i = [];
        this.showLoading(),
            this.mediaElements.forEach(({ element: n, optionNames: r, connects: o }) => {
                if (this.doesMediaMatchAllOptions(r, o)) {
                    const l = n.hasAttribute("hidden");
                    n.removeAttribute("hidden"), n.removeAttribute("data-gang-hidden"), t++, l && i.push(n);
                } else n.setAttribute("hidden", ""), n.setAttribute("data-gang-hidden", ""), e++;
            }),
            this.thumbnailElements.forEach(({ element: n, optionNames: r, connects: o }) => {
                this.doesMediaMatchAllOptions(r, o) ? n.removeAttribute("hidden") : n.setAttribute("hidden", "");
            }),
            h("Media visibility updated", "info", { visible: t, hidden: e }),
            this.monitorImageLoading(i),
            this.notifySliderUpdate();
    }
    doesMediaMatchAllOptions(t, e) {
        for (let i = 0; i < t.length; i++) {
            const n = t[i],
                r = e[i],
                o = this.currentOptions.get(n);
            if (!o) continue;
            const a = `${n}_${o}`;
            if (r !== a) return !1;
        }
        return !0;
    }
    showLoading() {
        this.classList.add(at),
            this.clearLoadingTimeout(),
            (this.loadingTimeout = window.setTimeout(() => {
                this.hideLoading(), h("Loading timeout reached", "warn");
            }, Mt));
    }
    hideLoading() {
        this.classList.remove(at), this.clearLoadingTimeout(), this.pendingImages.clear();
    }
    clearLoadingTimeout() {
        this.loadingTimeout && (window.clearTimeout(this.loadingTimeout), (this.loadingTimeout = null));
    }
    monitorImageLoading(t) {
        if (t.length === 0) {
            this.hideLoading();
            return;
        }
        t.forEach((e) => {
            const i = e.querySelector("img");
            if (!i || (i.complete && i.naturalHeight > 0)) return;
            this.pendingImages.add(i);
            const n = () => {
                this.pendingImages.delete(i),
                    i.removeEventListener("load", n),
                    i.removeEventListener("error", n),
                    this.pendingImages.size === 0 && this.hideLoading();
            };
            i.addEventListener("load", n), i.addEventListener("error", n);
        }),
            this.pendingImages.size === 0 && this.hideLoading();
    }
    notifySliderUpdate() {
        this.sliderElement &&
            (this.sliderElement.dispatchEvent(new CustomEvent("slider:content-changed", { bubbles: !0 })),
            this.sliderElement.refresh && this.sliderElement.refresh());
    }
    handleize(t) {
        return t
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/(^-|-$)/g, "");
    }
    disconnectedCallback() {
        this.variantSubscription?.unsubscribe(),
            document.removeEventListener("change", this.handleRadioChange.bind(this)),
            this.clearLoadingTimeout(),
            this.pendingImages.clear();
    }
}
typeof window < "u" &&
    !window.customElements.get("media-gallery-filter") &&
    window.customElements.define("media-gallery-filter", Rt);
class Pt extends C {
    constructor(t, e) {
        super(t, e),
            (this.componentName = "RegistryButtons"),
            (this.variantData = []),
            (this.currentVariantId = null),
            (this.isExpanded = !1),
            (this.variantSubscription = null);
    }
    getDefaultConfig() {
        return { triggerType: "click", animationDuration: bt.normal, buttonText: "Add to Registry" };
    }
    init() {
        this.cacheElementsAndData() &&
            (this.updateRegistryDisplay(), this.bindEvents(), h("RegistryButtons initialization complete", "info"));
    }
    cacheElementsAndData() {
        if (
            ((this.elements = {
                container: this.container,
                toggle: this.container.querySelector("[data-registry-toggle]"),
                grid: this.container.querySelector("[data-registry-grid]"),
            }),
            !y(this.container, "RegistryButtons container not found"))
        )
            return !1;
        const t = this.container.querySelector("[data-registry-data]");
        if (!y(t, "Registry data element not found")) return !1;
        try {
            (this.variantData = JSON.parse(t.textContent || "[]")), h("Parsed variant data", "info", this.variantData);
        } catch (i) {
            return h("Failed to parse registry data", "error", i), !1;
        }
        const e = this.container.getAttribute("data-variant-id");
        return e && (this.currentVariantId = parseInt(e, 10)), !0;
    }
    bindEvents() {
        y(this.elements.toggle, "Registry toggle element not found") &&
            (this.config.triggerType === "click"
                ? this.elements.toggle.addEventListener("click", (t) => {
                      t.preventDefault(), t.stopPropagation(), this.toggleExpansion();
                  })
                : (this.elements.toggle.addEventListener("mouseenter", () => this.expand()),
                  this.container.addEventListener("mouseleave", () => this.collapse())),
            (this.variantSubscription = it((t) => {
                t.detail?.variant?.id && ((this.currentVariantId = t.detail.variant.id), this.updateRegistryDisplay());
            })),
            this.config.triggerType === "click" &&
                ((this.boundOutsideClickHandler = (t) => {
                    !this.container.contains(t.target) && this.isExpanded && this.collapse();
                }),
                document.addEventListener("click", this.boundOutsideClickHandler)));
    }
    getSectionId() {
        return this.container.closest("[data-section-id]")?.getAttribute("data-section-id") || "";
    }
    toggleExpansion() {
        this.isExpanded ? this.collapse() : this.expand();
    }
    expand() {
        this.isExpanded ||
            (this.elements.toggle && this.elements.toggle.setAttribute("aria-expanded", "true"),
            this.container.classList.add("is-expanded"),
            (this.isExpanded = !0),
            this.container.dispatchEvent(new CustomEvent("registry:expanded", { bubbles: !0 })));
    }
    collapse() {
        this.isExpanded &&
            (this.elements.toggle && this.elements.toggle.setAttribute("aria-expanded", "false"),
            this.container.classList.remove("is-expanded"),
            (this.isExpanded = !1),
            this.container.dispatchEvent(new CustomEvent("registry:collapsed", { bubbles: !0 })));
    }
    updateRegistryDisplay() {
        if (!this.currentVariantId) {
            h("updateRegistryDisplay: No current variant ID", "warn");
            return;
        }
        const t = this.variantData.find((i) => i.id === this.currentVariantId);
        if (!t) {
            h("updateRegistryDisplay: Variant not found, hiding", "warn", this.currentVariantId), this.hide();
            return;
        }
        const e = t.registry_buttons.filter((i) => i.link && i.link.trim() !== "");
        if (e.length === 0) {
            this.hide();
            return;
        }
        this.show(), this.renderRegistries(e);
    }
    renderRegistries(t) {
        this.elements.grid &&
            (this.elements.grid.innerHTML = t
                .map(
                    (e) => `
          <a
            href="${e.link}"
            target="_blank"
            rel="noopener noreferrer"
            class="registry-button__item"
            id="registryButton"
            data-registry-name="${e.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}"
            aria-label="Add to ${e.name} registry"
          >
            <img
              src="${e.image}"
              alt="${e.name}"
              loading="lazy"
            />
          </a>
        `
                )
                .join(""));
    }
    show() {
        (this.container.hidden = !1), (this.container.style.display = "");
    }
    hide() {
        (this.container.hidden = !0), this.collapse();
    }
    destroy() {
        this.isDestroyed() ||
            (this.boundOutsideClickHandler && document.removeEventListener("click", this.boundOutsideClickHandler),
            this.variantSubscription && this.variantSubscription.unsubscribe(),
            this.isExpanded && this.collapse(),
            super.destroy());
    }
}
class Bt {
    constructor(t) {
        (this.modal = null),
            (this.titleElement = null),
            (this.contentElement = null),
            (this.triggers = null),
            (this.hsaFsaItem = null),
            (this.hsaFsaVariantData = []),
            (this.hsaFsaTitleElement = null),
            (this.hsaFsaTemplate = null),
            (this.pubsubUnsubscriber = null),
            (this.triggerClickHandlers = new Map()),
            (this.container = t),
            this.init();
    }
    init() {
        this.cacheElements() && (this.bindEvents(), this.initHsaFsa(), h("ProductTextDrawer initialized", "info"));
    }
    cacheElements() {
        const t = this.container.dataset.sectionId;
        return !t || ((this.modal = document.getElementById(`ProductTextDrawer-${t}`)), !this.modal)
            ? !1
            : ((this.titleElement = this.modal.querySelector("[data-drawer-title]")),
              (this.contentElement = this.modal.querySelector("[data-drawer-content]")),
              (this.triggers = this.container.querySelectorAll("[data-text-drawer-trigger]")),
              !!(this.titleElement && this.contentElement && this.triggers?.length));
    }
    bindEvents() {
        this.triggers &&
            ((this.boundTriggerClick = this.handleTriggerClick.bind(this)),
            this.triggers.forEach((t) => {
                this.triggerClickHandlers.set(t, this.boundTriggerClick),
                    t.addEventListener("click", this.boundTriggerClick);
            }));
    }
    initHsaFsa() {
        if (((this.hsaFsaItem = this.container.querySelector("[data-hsa-fsa-item]")), !this.hsaFsaItem)) return;
        const t = this.container.querySelector("[data-hsa-fsa-variants]");
        if (t)
            try {
                (this.hsaFsaVariantData = JSON.parse(t.textContent || "[]")),
                    h("Parsed HSA/FSA variant data", "info", this.hsaFsaVariantData);
            } catch {
                this.hsaFsaVariantData = [];
            }
        (this.hsaFsaTitleElement = this.hsaFsaItem.querySelector("[data-hsa-fsa-title]")),
            (this.hsaFsaTemplate = this.container.querySelector("[data-hsa-fsa-template]")),
            this.subscribeToPubsub();
    }
    subscribeToPubsub() {
        this.pubsubUnsubscriber ||
            vt(() => {
                const t = window;
                if (!t.theme?.pubsub) {
                    h("ProductTextDrawer: pubsub not available", "warn");
                    return;
                }
                (this.pubsubUnsubscriber = t.theme.pubsub.subscribe(
                    t.theme.pubsub.PUB_SUB_EVENTS.variantChange,
                    (e) => {
                        const n = e?.data?.variant?.id;
                        n && (h("HSA/FSA variant change via pubsub", "info", n), this.handleVariantChange(n));
                    }
                )),
                    h("ProductTextDrawer subscribed to pubsub", "info");
            });
    }
    handleVariantChange(t) {
        if (!this.hsaFsaItem) {
            h("HSA/FSA item not found", "warn");
            return;
        }
        const e = this.hsaFsaVariantData.find((i) => i.id === t);
        h("HSA/FSA variant lookup", "info", { variantId: t, found: !!e, title: e?.title }),
            e?.title
                ? ((this.hsaFsaItem.style.display = ""), this.updateHsaFsaContent(e))
                : (this.hsaFsaItem.style.display = "none");
    }
    updateHsaFsaContent(t) {
        h("Updating HSA/FSA content", "info", { title: t.title, hasContent: !!t.content }),
            this.hsaFsaTitleElement &&
                t.title &&
                ((this.hsaFsaTitleElement.textContent = t.title), h("Updated HSA/FSA title element", "info", t.title)),
            this.hsaFsaItem && (this.hsaFsaItem.dataset.drawerTitle = t.title || ""),
            this.hsaFsaTemplate && t.content && (this.hsaFsaTemplate.innerHTML = `<div class="rte">${t.content}</div>`);
    }
    handleTriggerClick(t) {
        const e = t.currentTarget,
            i = e.dataset.drawerTitle || "Information",
            n = e.dataset.drawerIcon || "",
            r = e.dataset.drawerContentId;
        if (!r) return;
        const o = document.getElementById(r);
        if (!o) return;
        if (this.titleElement) {
            const l = document.createElement("div");
            (l.className = "flex items-center gap-2d5"), n && (l.innerHTML = n);
            const c = document.createElement("div");
            (c.innerHTML = i), l.appendChild(c), (this.titleElement.innerHTML = ""), this.titleElement.appendChild(l);
        }
        if (this.contentElement) {
            const l = o.content.cloneNode(!0);
            (this.contentElement.innerHTML = ""), this.contentElement.appendChild(l);
        }
        const a = this.modal;
        a?.show && a.show();
    }
    destroy() {
        this.triggerClickHandlers.forEach((t, e) => {
            e.removeEventListener("click", t);
        }),
            this.triggerClickHandlers.clear(),
            this.pubsubUnsubscriber && (this.pubsubUnsubscriber(), (this.pubsubUnsubscriber = null));
    }
}
class Ot {
    constructor() {
        (this.TARGET_PRODUCT_IDS = new Set([7084852215947, 7984184426635])),
            (this.CAMERA_SCREEN_VARIANTS = new Set([
                "44499443155083",
                "44499443187851",
                "44463744581771",
                "44463744614539",
            ])),
            (this.CAMERA_ONLY_VARIANTS = new Set([
                "41234392973451",
                "41234392187019",
                "44463730294923",
                "44463730327691",
            ])),
            (this.currentProductId = null),
            (this.isInitialized = !1),
            (this.pubsubUnsubscriber = null);
    }
    init(t, e) {
        if (!this.isInitialized) {
            if (
                ((this.currentProductId = t ?? null),
                !this.currentProductId || !this.TARGET_PRODUCT_IDS.has(this.currentProductId))
            ) {
                h("ProductTitleManager: Not a target product, skipping", "info");
                return;
            }
            h("ProductTitleManager: Initializing for product", "info", this.currentProductId),
                e && this.updateTitleVisibility(String(e)),
                this.subscribeToPubsub(),
                (this.isInitialized = !0);
        }
    }
    subscribeToPubsub() {
        vt(() => {
            const t = window;
            if (!t.theme?.pubsub) {
                h("ProductTitleManager: pubsub not available", "warn");
                return;
            }
            try {
                (this.pubsubUnsubscriber = t.theme.pubsub.subscribe(
                    t.theme.pubsub.PUB_SUB_EVENTS.variantChange,
                    (e) => {
                        const i = e,
                            n = i?.data?.productId,
                            r = i?.data?.variant?.id;
                        if (
                            !(
                                this.currentProductId &&
                                n &&
                                (typeof n == "string" ? parseInt(n, 10) : n) !== this.currentProductId
                            ) &&
                            r
                        ) {
                            const o = String(r);
                            h("ProductTitleManager: Variant changed", "info", o), this.updateTitleVisibility(o);
                        }
                    }
                )),
                    h("ProductTitleManager: Subscribed to pubsub", "info");
            } catch (e) {
                h("ProductTitleManager: Error subscribing to pubsub", "error", e);
            }
        });
    }
    updateTitleVisibility(t) {
        const e = this.CAMERA_SCREEN_VARIANTS.has(t),
            i = this.CAMERA_ONLY_VARIANTS.has(t);
        let n = "default";
        e ? (n = "camera-screen") : i && (n = "camera-only"),
            document.body.setAttribute("data-product-title-variant", n),
            h("ProductTitleManager: Set title variant", "info", n);
    }
    cleanup() {
        this.pubsubUnsubscriber && (this.pubsubUnsubscriber(), (this.pubsubUnsubscriber = null)),
            document.body.removeAttribute("data-product-title-variant"),
            (this.isInitialized = !1),
            h("ProductTitleManager: Cleaned up", "info");
    }
}
const lt = new Ot();
class Dt extends C {
    constructor(t, e = {}) {
        super(t, e),
            (this.componentName = "MainProduct"),
            (this.recommendationsElements = null),
            (this.registryButtonsComponent = null),
            (this.textDrawerComponent = null);
    }
    getDefaultConfig() {
        return {
            productId: this.container.dataset.productId || "",
            sectionId: this.container.dataset.sectionId || "",
            debug: !1,
        };
    }
    init() {
        this.log("Starting MainProduct initialization"),
            this.cacheElementsAndSetup() &&
                (this.initProductRecommendations(),
                this.initRegistryButtons(),
                this.initTextDrawer(),
                this.initProductTitleManager(),
                this.bindEvents(),
                this.log("Component initialized"));
    }
    initProductTitleManager() {
        const t = parseInt(this.config.productId, 10),
            i = new URLSearchParams(window.location.search).get("variant"),
            n = i
                ? parseInt(i, 10)
                : this.container.dataset.currentVariantId
                  ? parseInt(this.container.dataset.currentVariantId, 10)
                  : void 0;
        t && (lt.init(t, n), this.log("ProductTitleManager initialized"));
    }
    cacheElementsAndSetup() {
        return (
            this.container.tagName.toLowerCase() === "product-info"
                ? ((this.elements = {
                      productInfo: this.container,
                      productRecommendations: null,
                      registryButtons: null,
                  }),
                  this.log("Container is product-info element"))
                : (this.elements = L(this.container, {
                      productInfo: "product-info",
                      productRecommendations: "product-recommendations",
                      registryButtons: "[data-registry-buttons]",
                  })),
            (this.recommendationsElements = this.container.querySelectorAll("product-recommendations")),
            this.log(`Found ${this.recommendationsElements.length} recommendation elements`),
            !0
        );
    }
    initProductRecommendations() {
        if (!this.recommendationsElements?.length) {
            this.log("No product recommendations elements found");
            return;
        }
        this.recommendationsElements.forEach((t) => {
            const e = t;
            e.__mainProductInitialized ||
                ((e.__mainProductInitialized = !0), this.log("Product recommendations element initialized"));
        });
    }
    initRegistryButtons() {
        const t = this.elements.registryButtons;
        if (!t) {
            this.log("No registry buttons element found");
            return;
        }
        const e = t.dataset.triggerType || "click";
        (this.registryButtonsComponent = new Pt(t, { triggerType: e })), this.log("Registry buttons initialized");
    }
    initTextDrawer() {
        (this.textDrawerComponent = new Bt(this.container)), this.log("Text drawer initialized");
    }
    bindEvents() {
        (this.boundRecommendationsLoaded = this.handleRecommendationsLoaded.bind(this)),
            (this.boundRecommendationsError = this.handleRecommendationsError.bind(this)),
            this.container.addEventListener("recommendations:loaded", this.boundRecommendationsLoaded),
            this.container.addEventListener("recommendations:error", this.boundRecommendationsError);
    }
    handleRecommendationsLoaded(t) {
        const e = t,
            { count: i, productId: n } = e.detail;
        this.log(`Recommendations loaded - ${i} products for ${n}`);
    }
    handleRecommendationsError(t) {
        const e = t,
            { error: i, productId: n } = e.detail;
        this.log(`Recommendations error for ${n} - ${i}`, "error");
    }
    selectBlock(t) {
        this.log(`Block selected: ${t}`);
    }
    deselectBlock(t) {
        this.log(`Block deselected: ${t}`);
    }
    refreshRecommendations() {
        this.recommendationsElements?.length &&
            this.recommendationsElements.forEach((t) => {
                const e = t;
                e.refresh && e.refresh();
            });
    }
    destroy() {
        this.isDestroyed() ||
            (this.container.removeEventListener("recommendations:loaded", this.boundRecommendationsLoaded),
            this.container.removeEventListener("recommendations:error", this.boundRecommendationsError),
            this.recommendationsElements?.length &&
                this.recommendationsElements.forEach((t) => {
                    typeof t.destroy == "function" && t.destroy();
                }),
            this.registryButtonsComponent?.destroy(),
            this.textDrawerComponent?.destroy(),
            lt.cleanup(),
            super.destroy(),
            this.log("Component destroyed"));
    }
}
class Vt {
    constructor(t) {
        (this.expandableCards = null),
            (this.expandableCards = t),
            (this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    }
    async expandCard(t) {
        const { element: e, statusPill: i, subtitle: n } = t;
        if (
            (i && (i.hidden = !1),
            n && (n.hidden = !1),
            e.setAttribute("data-expanded", "true"),
            !this.prefersReducedMotion)
        )
            return new Promise((r) => {
                const o = () => {
                    e.removeEventListener("transitionend", o), r();
                };
                e.addEventListener("transitionend", o);
            });
    }
    async collapseCard(t) {
        const { element: e, statusPill: i, subtitle: n } = t;
        e.setAttribute("data-expanded", "false"),
            this.prefersReducedMotion ||
                (await new Promise((r) => {
                    const o = () => {
                        e.removeEventListener("transitionend", o), r();
                    };
                    e.addEventListener("transitionend", o);
                })),
            i && (i.hidden = !0),
            n && (n.hidden = !0);
    }
}
const Ht = 250;
class qt extends C {
    constructor(t) {
        super(t),
            (this.componentName = "BenefitsCards"),
            (this.expandedCard = null),
            (this.animationController = null),
            (this.isMobile = !1),
            (this.intersectionObserver = null),
            (this.isVisible = !1),
            (this.currentSlideIndex = 0),
            (this.modalElement = null),
            (this.modalSliderElement = null),
            (this.isModalOpen = !1),
            (this.isProgrammaticScroll = !1),
            (this.cardStates = new Map()),
            this.initializeCards();
    }
    getDefaultConfig() {
        return {
            autoCloseSiblings: !0,
            debug: !0,
            enableIntersection: !1,
            enableAnimations: !0,
            respectReducedMotion: !0,
            threshold: 0.1,
            rootMargin: "50px",
        };
    }
    init() {
        this.cacheElementsAndConfig() &&
            ((this.boundKeyHandler = this.handleGlobalKeydown.bind(this)),
            (this.boundResizeHandler = k(this.handleResize.bind(this), Ht)),
            (this.boundScrollHandler = k(this.handleScroll.bind(this), 100)),
            this.detectMobile(),
            this.initializeAnimationController(),
            this.setupIntersectionObserver(),
            this.setupGlobalEventHandlers(),
            this.setupPaginationDots(),
            this.setupNavigationControls(),
            this.updateProgress());
    }
    cacheElementsAndConfig() {
        if (
            ((this.elements = L(this.container, {
                expandableCards: ".expandable-cards",
                cards: ".exp-card",
                actionBtn: ".exp-card__action-btn",
                img: ".exp-card__img",
                statusPill: ".exp-card__status-pill",
                subtitle: ".subtitle",
                sliderElement: "slider-element",
                sliderDots: "slider-dots",
                paginationDots: ".slider-pagination__dot",
                controls: "[data-controls]",
                prevBtn: "[data-prev]",
                nextBtn: "[data-next]",
                progressBar: "[data-progress-bar]",
            })),
            !y(this.elements.expandableCards, "[Benefits Cards] Expandable cards container not found"))
        )
            return !1;
        const t = this.elements.expandableCards.dataset || {};
        return (this.config = { ...this.config, autoCloseSiblings: t.autoClose === "true" }), !0;
    }
    detectMobile() {
        this.isMobile = window.innerWidth < nt.lg;
    }
    initializeAnimationController() {
        this.animationController = new Vt(this.elements.expandableCards);
    }
    initializeCards() {
        if (!this.cardStates) return;
        this.container.querySelectorAll(".exp-card").forEach((e, i) => {
            const n = e,
                r = n.dataset.blockId || `card-${i}`,
                o = this.createCardState(n);
            o && (this.cardStates.set(r, o), this.setupCardEvents(r, o));
        });
    }
    createCardState(t) {
        const e = t.querySelector(".exp-card__action-btn"),
            i = t.querySelector(".exp-card__img"),
            n = t.querySelector(".exp-card__status-pill"),
            r = t.querySelector(".subtitle");
        return y(e, "Action button not found for card")
            ? { isExpanded: !1, element: t, actionBtn: e, img: i, statusPill: n, subtitle: r }
            : null;
    }
    setupCardEvents(t, e) {
        const { element: i } = e,
            n = async (r) => {
                if ((r.preventDefault(), this.isDestroyed())) return;
                h("Card clicked", "info", { blockId: t, isExpanded: e.isExpanded });
                const o = this.isCardInView(i);
                if (this.isMobile) {
                    o
                        ? this.openModal(t)
                        : (h("Mobile: Card off-screen, scrolling first", "info", t),
                          await this.scrollToCardThenOpenModal(t, e));
                    return;
                }
                if (e.isExpanded) {
                    h("Collapsing card", "info", t), this.collapseCard(t);
                    return;
                }
                o
                    ? (h("Expanding card", "info", t), this.expandCard(t))
                    : (h("Card off-screen, scrolling first", "info", t), await this.scrollToCardAndExpand(t, e));
            };
        i.addEventListener("click", n),
            i.addEventListener("keydown", (r) => {
                (r.key === "Enter" || r.key === " ") && n(r);
            }),
            i.setAttribute("tabindex", "0"),
            i.setAttribute("role", "button"),
            i.setAttribute("aria-expanded", "false");
    }
    async scrollToCardThenOpenModal(t, e) {
        const i = this.container.querySelector(".expandable-cards__grid");
        if (!i) {
            this.openModal(t);
            return;
        }
        const r = e.element.offsetLeft;
        (this.isProgrammaticScroll = !0),
            i.scrollTo({ left: Math.max(0, r), behavior: "smooth" }),
            await new Promise((o) => {
                const a = () => {
                    i.removeEventListener("scrollend", a), o();
                };
                "onscrollend" in window
                    ? i.addEventListener("scrollend", a, { once: !0 })
                    : globalThis.setTimeout(o, 400);
            }),
            (this.isProgrammaticScroll = !1),
            this.openModal(t);
    }
    async scrollToCardAndExpand(t, e) {
        const i = this.container.querySelector(".expandable-cards__grid");
        if (!i) {
            this.expandCard(t);
            return;
        }
        const r = e.element.offsetLeft - 24;
        (this.isProgrammaticScroll = !0),
            i.scrollTo({ left: Math.max(0, r), behavior: "smooth" }),
            await new Promise((o) => {
                const a = () => {
                    i.removeEventListener("scrollend", a), o();
                };
                "onscrollend" in window
                    ? i.addEventListener("scrollend", a, { once: !0 })
                    : globalThis.setTimeout(o, 400);
            }),
            (this.isProgrammaticScroll = !1),
            this.expandCard(t);
    }
    openModal(t) {
        if (
            ((this.modalElement = this.container.querySelector(".benefits-modal")),
            (this.modalSliderElement = this.container.querySelector(".benefits-modal__slides")),
            !this.modalElement || !this.modalSliderElement)
        ) {
            h("Modal elements not found", "warn");
            return;
        }
        const i = Array.from(this.container.querySelectorAll(".exp-card")).findIndex((r) => r.dataset.blockId === t);
        if (i === -1) return;
        (this.isModalOpen = !0),
            this.modalElement.removeAttribute("hidden"),
            this.modalElement.setAttribute("data-open", "true"),
            this.modalElement.setAttribute("data-animating", "true");
        const n = this.modalSliderElement.querySelectorAll(".benefits-modal__slide");
        n[i] && this.modalSliderElement.scrollTo({ left: n[i].offsetLeft, behavior: "instant" }),
            this.setupModalEvents(),
            window.setTimeout(() => {
                this.modalElement?.removeAttribute("data-animating");
            }, 400),
            (document.body.style.overflow = "hidden"),
            document.body.classList.add("benefits-modal-open"),
            h("Modal opened", "info", { blockId: t, index: i });
    }
    closeModal() {
        this.modalElement &&
            (this.modalElement.setAttribute("data-animating", "true"),
            this.modalElement.setAttribute("data-open", "false"),
            window.setTimeout(() => {
                this.modalElement?.setAttribute("hidden", ""),
                    this.modalElement?.removeAttribute("data-animating"),
                    (this.isModalOpen = !1),
                    (document.body.style.overflow = ""),
                    document.body.classList.remove("benefits-modal-open");
            }, 400),
            h("Modal closed", "info"));
    }
    setupModalEvents() {
        if (!this.modalElement || !this.modalSliderElement) return;
        const t = this.modalElement.querySelector("[data-modal-close]");
        if (t) {
            const o = () => this.closeModal();
            t.addEventListener("click", o, { once: !0 });
        }
        const e = this.modalElement.querySelector(".benefits-modal__backdrop");
        if (e) {
            const o = () => this.closeModal();
            e.addEventListener("click", o, { once: !0 });
        }
        const i = (o) => {
            o.key === "Escape" && this.isModalOpen && (this.closeModal(), document.removeEventListener("keydown", i));
        };
        document.addEventListener("keydown", i);
        const n = this.modalElement.querySelectorAll("[data-modal-pagination] button");
        n.forEach((o, a) => {
            o.addEventListener("click", () => {
                if (this.modalSliderElement) {
                    const l = this.modalSliderElement.querySelectorAll(".benefits-modal__slide");
                    l[a] && this.modalSliderElement.scrollTo({ left: l[a].offsetLeft, behavior: "smooth" });
                }
            });
        });
        const r = () => {
            if (!this.modalSliderElement) return;
            const o = this.modalSliderElement.querySelectorAll(".benefits-modal__slide"),
                a = this.modalSliderElement.scrollLeft;
            let l = 0,
                c = 1 / 0;
            o.forEach((d, u) => {
                const f = d.offsetLeft,
                    m = Math.abs(a - f);
                m < c && ((c = m), (l = u));
            }),
                n.forEach((d, u) => {
                    u === l ? d.classList.add("is-active") : d.classList.remove("is-active");
                }),
                (this.currentSlideIndex = l),
                this.updatePaginationDots(l);
        };
        this.modalSliderElement.addEventListener("scroll", r, { passive: !0 });
    }
    async expandCard(t) {
        const e = this.cardStates.get(t);
        if (!(!e || e.isExpanded)) {
            (this.config?.autoCloseSiblings ?? !0) && this.expandedCard && (await this.collapseCard(this.expandedCard)),
                (e.isExpanded = !0),
                (this.expandedCard = t),
                e.element.setAttribute("aria-expanded", "true");
            try {
                this.animationController
                    ? await this.animationController.expandCard(e)
                    : e.element.setAttribute("data-expanded", "true");
            } catch {
                e.element.setAttribute("data-expanded", "true");
            }
            this.focusActionButton(e), this.scrollToCard(e);
        }
    }
    async collapseCard(t) {
        const e = this.cardStates.get(t);
        if (!(!e || !e.isExpanded)) {
            (e.isExpanded = !1), (this.expandedCard = null), e.element.setAttribute("aria-expanded", "false");
            try {
                this.animationController
                    ? await this.animationController.collapseCard(e)
                    : e.element.setAttribute("data-expanded", "false");
            } catch {
                e.element.setAttribute("data-expanded", "false");
            }
            this.focusActionButton(e);
        }
    }
    focusActionButton(t) {
        t.actionBtn.focus();
    }
    scrollToCard(t) {
        const e = this.container.querySelector(".expandable-cards__grid");
        e &&
            window.requestAnimationFrame(() => {
                const i = t.element.offsetLeft,
                    n = e.clientWidth,
                    r = t.element.offsetWidth,
                    o = i - n / 2 + r / 2,
                    a = e.scrollWidth - n;
                e.scrollTo({ left: Math.max(0, Math.min(o, a)), behavior: "smooth" });
            });
    }
    setupPaginationDots() {
        const t = this.container.querySelector(".expandable-cards__grid");
        if (!t) {
            h("Scroll container not found", "warn");
            return;
        }
        const e = this.container.querySelectorAll(".slider-pagination__dot");
        e.forEach((i, n) => {
            i.addEventListener("click", (r) => {
                r.preventDefault(), this.scrollToSlide(n);
            });
        }),
            t.addEventListener("scroll", this.boundScrollHandler),
            e.length > 0 && h("Pagination dots initialized", "info", { dotsCount: e.length });
    }
    scrollToSlide(t) {
        const e = this.container.querySelector(".expandable-cards__grid"),
            i = this.container.querySelectorAll(".exp-card");
        if (!e || t < 0 || t >= i.length) return;
        const o = i[t].offsetLeft;
        (this.isProgrammaticScroll = !0),
            e.scrollTo({ left: Math.max(0, o), behavior: "smooth" }),
            (this.currentSlideIndex = t),
            this.updatePaginationDots(t),
            this.updateNavigationButtons(),
            this.updateProgress(),
            window.setTimeout(() => {
                this.isProgrammaticScroll = !1;
            }, 600);
    }
    handleScroll() {
        const t = this.container.querySelector(".expandable-cards__grid"),
            e = this.container.querySelectorAll(".exp-card");
        if (!t || e.length === 0 || this.isProgrammaticScroll) return;
        const i = t.scrollLeft;
        let n = 0,
            r = 1 / 0;
        e.forEach((o, a) => {
            const l = o.offsetLeft,
                c = Math.abs(l - i);
            c < r && ((r = c), (n = a));
        }),
            n !== this.currentSlideIndex &&
                ((this.currentSlideIndex = n), this.updatePaginationDots(n), this.updateNavigationButtons()),
            this.updateProgress();
    }
    updatePaginationDots(t) {
        this.container.querySelectorAll(".slider-pagination__dot").forEach((i, n) => {
            const r = n === t;
            i.setAttribute("aria-current", r ? "true" : "false");
        });
    }
    setupNavigationControls() {
        const t = this.elements.prevBtn,
            e = this.elements.nextBtn;
        t && t.addEventListener("click", () => this.navigatePrev()),
            e && e.addEventListener("click", () => this.navigateNext()),
            this.updateNavigationButtons();
    }
    navigatePrev() {
        const t = this.container.querySelector(".expandable-cards__grid"),
            e = this.container.querySelectorAll(".exp-card");
        if (!t || e.length === 0) return;
        const i = Math.max(0, this.currentSlideIndex - 1);
        this.scrollToSlide(i);
    }
    navigateNext() {
        const t = this.container.querySelector(".expandable-cards__grid"),
            e = this.container.querySelectorAll(".exp-card");
        if (!t || e.length === 0) return;
        const i = Math.min(e.length - 1, this.currentSlideIndex + 1);
        this.scrollToSlide(i);
    }
    updateNavigationButtons() {
        const t = this.elements.prevBtn,
            e = this.elements.nextBtn,
            n = this.container.querySelectorAll(".exp-card").length;
        t && (t.disabled = this.currentSlideIndex === 0), e && (e.disabled = this.currentSlideIndex >= n - 1);
    }
    updateProgress() {
        const t = this.elements.progressBar,
            e = this.container.querySelectorAll(".exp-card"),
            i = this.container.querySelector(".expandable-cards__grid");
        if (!t || !i || e.length === 0) return;
        const n = i.scrollLeft,
            r = i.scrollWidth - i.clientWidth,
            o = r > 0 ? (n / r) * 100 : 0;
        t.style.width = `${Math.min(100, Math.max(0, o))}%`;
        const a = t.parentElement;
        a && a.setAttribute("aria-valuenow", String(Math.round(o)));
    }
    isCardInView(t) {
        const e = this.container.querySelector(".expandable-cards__grid");
        if (!e) return !1;
        const i = e.getBoundingClientRect(),
            n = t.getBoundingClientRect(),
            r = 50;
        return n.left >= i.left - r && n.right <= i.right + r;
    }
    setupGlobalEventHandlers() {
        document.addEventListener("keydown", this.boundKeyHandler),
            window.addEventListener("resize", this.boundResizeHandler);
    }
    handleGlobalKeydown(t) {
        t.key === "Escape" && this.expandedCard && this.collapseCard(this.expandedCard);
    }
    handleResize() {
        this.detectMobile();
    }
    setupIntersectionObserver() {
        this.config.enableIntersection &&
            ((this.intersectionObserver = new IntersectionObserver(
                (t) => {
                    t.forEach((e) => {
                        e.isIntersecting && !this.isVisible
                            ? (this.isVisible = !0)
                            : !e.isIntersecting && this.isVisible && (this.isVisible = !1);
                    });
                },
                { threshold: this.config.threshold || 0.1, rootMargin: this.config.rootMargin || "50px" }
            )),
            this.intersectionObserver.observe(this.container));
    }
    selectBlock(t) {
        this.expandCard(t);
    }
    deselectBlock(t) {
        this.expandedCard === t && this.collapseCard(t);
    }
    destroy() {
        if (this.isDestroyed()) return;
        document.removeEventListener("keydown", this.boundKeyHandler),
            window.removeEventListener("resize", this.boundResizeHandler);
        const t = this.container.querySelector(".expandable-cards__grid");
        t && t.removeEventListener("scroll", this.boundScrollHandler),
            this.intersectionObserver && (this.intersectionObserver.disconnect(), (this.intersectionObserver = null)),
            this.cardStates.clear(),
            super.destroy();
    }
}
function ct(s, t) {
    var e = Object.keys(s);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(s);
        t &&
            (i = i.filter(function (n) {
                return Object.getOwnPropertyDescriptor(s, n).enumerable;
            })),
            e.push.apply(e, i);
    }
    return e;
}
function dt(s) {
    for (var t = 1; t < arguments.length; t++) {
        var e = arguments[t] != null ? arguments[t] : {};
        t % 2
            ? ct(Object(e), !0).forEach(function (i) {
                  Nt(s, i, e[i]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(e))
              : ct(Object(e)).forEach(function (i) {
                    Object.defineProperty(s, i, Object.getOwnPropertyDescriptor(e, i));
                });
    }
    return s;
}
function q(s) {
    "@babel/helpers - typeof";
    return (
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
            ? (q = function (t) {
                  return typeof t;
              })
            : (q = function (t) {
                  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
              }),
        q(s)
    );
}
function F(s, t) {
    if (!(s instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $t(s, t) {
    for (var e = 0; e < t.length; e++) {
        var i = t[e];
        (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(s, i.key, i);
    }
}
function U(s, t, e) {
    return t && $t(s.prototype, t), s;
}
function Nt(s, t, e) {
    return (
        t in s ? Object.defineProperty(s, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : (s[t] = e),
        s
    );
}
function zt(s, t) {
    if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
    (s.prototype = Object.create(t && t.prototype, { constructor: { value: s, writable: !0, configurable: !0 } })),
        t && J(s, t);
}
function I(s) {
    return (
        (I = Object.setPrototypeOf
            ? Object.getPrototypeOf
            : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
              }),
        I(s)
    );
}
function J(s, t) {
    return (
        (J =
            Object.setPrototypeOf ||
            function (i, n) {
                return (i.__proto__ = n), i;
            }),
        J(s, t)
    );
}
function Ft() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch {
        return !1;
    }
}
function Ut(s) {
    if (s === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return s;
}
function jt(s, t) {
    if (t && (typeof t == "object" || typeof t == "function")) return t;
    if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return Ut(s);
}
function Wt(s) {
    var t = Ft();
    return function () {
        var i = I(s),
            n;
        if (t) {
            var r = I(this).constructor;
            n = Reflect.construct(i, arguments, r);
        } else n = i.apply(this, arguments);
        return jt(this, n);
    };
}
function Kt(s, t) {
    for (; !Object.prototype.hasOwnProperty.call(s, t) && ((s = I(s)), s !== null); );
    return s;
}
function $() {
    return (
        typeof Reflect < "u" && Reflect.get
            ? ($ = Reflect.get)
            : ($ = function (t, e, i) {
                  var n = Kt(t, e);
                  if (n) {
                      var r = Object.getOwnPropertyDescriptor(n, e);
                      return r.get ? r.get.call(arguments.length < 3 ? t : i) : r.value;
                  }
              }),
        $.apply(this, arguments)
    );
}
var Yt = {
    type: "slider",
    startAt: 0,
    perView: 1,
    focusAt: 0,
    gap: 10,
    autoplay: !1,
    hoverpause: !0,
    keyboard: !0,
    bound: !1,
    swipeThreshold: 80,
    dragThreshold: 120,
    perSwipe: "",
    touchRatio: 0.5,
    touchAngle: 45,
    animationDuration: 400,
    rewind: !0,
    rewindDuration: 800,
    animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    waitForTransition: !0,
    throttle: 10,
    direction: "ltr",
    peek: 0,
    cloningRatio: 1,
    breakpoints: {},
    classes: {
        swipeable: "glide--swipeable",
        dragging: "glide--dragging",
        direction: { ltr: "glide--ltr", rtl: "glide--rtl" },
        type: { slider: "glide--slider", carousel: "glide--carousel" },
        slide: { clone: "glide__slide--clone", active: "glide__slide--active" },
        arrow: { disabled: "glide__arrow--disabled" },
        nav: { active: "glide__bullet--active" },
    },
};
function _(s) {
    console.error("[Glide warn]: ".concat(s));
}
function b(s) {
    return parseInt(s);
}
function Xt(s) {
    return parseFloat(s);
}
function Z(s) {
    return typeof s == "string";
}
function M(s) {
    var t = q(s);
    return t === "function" || (t === "object" && !!s);
}
function N(s) {
    return typeof s == "function";
}
function yt(s) {
    return typeof s > "u";
}
function Q(s) {
    return s.constructor === Array;
}
function Jt(s, t, e) {
    var i = {};
    for (var n in t) N(t[n]) ? (i[n] = t[n](s, i, e)) : _("Extension must be a function");
    for (var r in i) N(i[r].mount) && i[r].mount();
    return i;
}
function g(s, t, e) {
    Object.defineProperty(s, t, e);
}
function Zt(s) {
    return Object.keys(s)
        .sort()
        .reduce(function (t, e) {
            return (t[e] = s[e]), t[e], t;
        }, {});
}
function G(s, t) {
    var e = Object.assign({}, s, t);
    if (t.hasOwnProperty("classes")) {
        e.classes = Object.assign({}, s.classes, t.classes);
        var i = ["direction", "type", "slide", "arrow", "nav"];
        i.forEach(function (n) {
            t.classes.hasOwnProperty(n) && (e.classes[n] = dt(dt({}, s.classes[n]), t.classes[n]));
        });
    }
    return t.hasOwnProperty("breakpoints") && (e.breakpoints = Object.assign({}, s.breakpoints, t.breakpoints)), e;
}
var Qt = (function () {
        function s() {
            var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            F(this, s), (this.events = t), (this.hop = t.hasOwnProperty);
        }
        return (
            U(s, [
                {
                    key: "on",
                    value: function (e, i) {
                        if (Q(e)) {
                            for (var n = 0; n < e.length; n++) this.on(e[n], i);
                            return;
                        }
                        this.hop.call(this.events, e) || (this.events[e] = []);
                        var r = this.events[e].push(i) - 1;
                        return {
                            remove: function () {
                                delete this.events[e][r];
                            },
                        };
                    },
                },
                {
                    key: "emit",
                    value: function (e, i) {
                        if (Q(e)) {
                            for (var n = 0; n < e.length; n++) this.emit(e[n], i);
                            return;
                        }
                        this.hop.call(this.events, e) &&
                            this.events[e].forEach(function (r) {
                                r(i || {});
                            });
                    },
                },
            ]),
            s
        );
    })(),
    Gt = (function () {
        function s(t) {
            var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            F(this, s),
                (this._c = {}),
                (this._t = []),
                (this._e = new Qt()),
                (this.disabled = !1),
                (this.selector = t),
                (this.settings = G(Yt, e)),
                (this.index = this.settings.startAt);
        }
        return (
            U(s, [
                {
                    key: "mount",
                    value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        return (
                            this._e.emit("mount.before"),
                            M(e) ? (this._c = Jt(this, e, this._e)) : _("You need to provide a object on `mount()`"),
                            this._e.emit("mount.after"),
                            this
                        );
                    },
                },
                {
                    key: "mutate",
                    value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        return Q(e) ? (this._t = e) : _("You need to provide a array on `mutate()`"), this;
                    },
                },
                {
                    key: "update",
                    value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        return (
                            (this.settings = G(this.settings, e)),
                            e.hasOwnProperty("startAt") && (this.index = e.startAt),
                            this._e.emit("update"),
                            this
                        );
                    },
                },
                {
                    key: "go",
                    value: function (e) {
                        return this._c.Run.make(e), this;
                    },
                },
                {
                    key: "move",
                    value: function (e) {
                        return this._c.Transition.disable(), this._c.Move.make(e), this;
                    },
                },
                {
                    key: "destroy",
                    value: function () {
                        return this._e.emit("destroy"), this;
                    },
                },
                {
                    key: "play",
                    value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                        return e && (this.settings.autoplay = e), this._e.emit("play"), this;
                    },
                },
                {
                    key: "pause",
                    value: function () {
                        return this._e.emit("pause"), this;
                    },
                },
                {
                    key: "disable",
                    value: function () {
                        return (this.disabled = !0), this;
                    },
                },
                {
                    key: "enable",
                    value: function () {
                        return (this.disabled = !1), this;
                    },
                },
                {
                    key: "on",
                    value: function (e, i) {
                        return this._e.on(e, i), this;
                    },
                },
                {
                    key: "isType",
                    value: function (e) {
                        return this.settings.type === e;
                    },
                },
                {
                    key: "settings",
                    get: function () {
                        return this._o;
                    },
                    set: function (e) {
                        M(e) ? (this._o = e) : _("Options must be an `object` instance.");
                    },
                },
                {
                    key: "index",
                    get: function () {
                        return this._i;
                    },
                    set: function (e) {
                        this._i = b(e);
                    },
                },
                {
                    key: "type",
                    get: function () {
                        return this.settings.type;
                    },
                },
                {
                    key: "disabled",
                    get: function () {
                        return this._d;
                    },
                    set: function (e) {
                        this._d = !!e;
                    },
                },
            ]),
            s
        );
    })();
function te(s, t, e) {
    var i = {
        mount: function () {
            this._o = !1;
        },
        make: function (c) {
            var d = this;
            s.disabled ||
                (!s.settings.waitForTransition || s.disable(),
                (this.move = c),
                e.emit("run.before", this.move),
                this.calculate(),
                e.emit("run", this.move),
                t.Transition.after(function () {
                    d.isStart() && e.emit("run.start", d.move),
                        d.isEnd() && e.emit("run.end", d.move),
                        d.isOffset() && ((d._o = !1), e.emit("run.offset", d.move)),
                        e.emit("run.after", d.move),
                        s.enable();
                }));
        },
        calculate: function () {
            var c = this.move,
                d = this.length,
                u = c.steps,
                f = c.direction,
                m = 1;
            if (f === "=") {
                if (s.settings.bound && b(u) > d) {
                    s.index = d;
                    return;
                }
                s.index = u;
                return;
            }
            if (f === ">" && u === ">") {
                s.index = d;
                return;
            }
            if (f === "<" && u === "<") {
                s.index = 0;
                return;
            }
            if ((f === "|" && (m = s.settings.perView || 1), f === ">" || (f === "|" && u === ">"))) {
                var p = n(m);
                p > d && (this._o = !0), (s.index = r(p, m));
                return;
            }
            if (f === "<" || (f === "|" && u === "<")) {
                var v = o(m);
                v < 0 && (this._o = !0), (s.index = a(v, m));
                return;
            }
            _("Invalid direction pattern [".concat(f).concat(u, "] has been used"));
        },
        isStart: function () {
            return s.index <= 0;
        },
        isEnd: function () {
            return s.index >= this.length;
        },
        isOffset: function () {
            var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
            return c
                ? this._o
                    ? c === "|>"
                        ? this.move.direction === "|" && this.move.steps === ">"
                        : c === "|<"
                          ? this.move.direction === "|" && this.move.steps === "<"
                          : this.move.direction === c
                    : !1
                : this._o;
        },
        isBound: function () {
            return s.isType("slider") && s.settings.focusAt !== "center" && s.settings.bound;
        },
    };
    function n(l) {
        var c = s.index;
        return s.isType("carousel") ? c + l : c + (l - (c % l));
    }
    function r(l, c) {
        var d = i.length;
        return l <= d
            ? l
            : s.isType("carousel")
              ? l - (d + 1)
              : s.settings.rewind
                ? i.isBound() && !i.isEnd()
                    ? d
                    : 0
                : i.isBound()
                  ? d
                  : Math.floor(d / c) * c;
    }
    function o(l) {
        var c = s.index;
        if (s.isType("carousel")) return c - l;
        var d = Math.ceil(c / l);
        return (d - 1) * l;
    }
    function a(l, c) {
        var d = i.length;
        return l >= 0
            ? l
            : s.isType("carousel")
              ? l + (d + 1)
              : s.settings.rewind
                ? i.isBound() && i.isStart()
                    ? d
                    : Math.floor(d / c) * c
                : 0;
    }
    return (
        g(i, "move", {
            get: function () {
                return this._m;
            },
            set: function (c) {
                var d = c.substr(1);
                this._m = { direction: c.substr(0, 1), steps: d ? (b(d) ? b(d) : d) : 0 };
            },
        }),
        g(i, "length", {
            get: function () {
                var c = s.settings,
                    d = t.Html.slides.length;
                return this.isBound() ? d - 1 - (b(c.perView) - 1) + b(c.focusAt) : d - 1;
            },
        }),
        g(i, "offset", {
            get: function () {
                return this._o;
            },
        }),
        i
    );
}
function ut() {
    return new Date().getTime();
}
function j(s, t) {
    var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
        i,
        n,
        r,
        o,
        a = 0,
        l = function () {
            (a = e.leading === !1 ? 0 : ut()), (i = null), (o = s.apply(n, r)), i || (n = r = null);
        },
        c = function () {
            var u = ut();
            !a && e.leading === !1 && (a = u);
            var f = t - (u - a);
            return (
                (n = this),
                (r = arguments),
                f <= 0 || f > t
                    ? (i && (clearTimeout(i), (i = null)), (a = u), (o = s.apply(n, r)), i || (n = r = null))
                    : !i && e.trailing !== !1 && (i = setTimeout(l, f)),
                o
            );
        };
    return (
        (c.cancel = function () {
            clearTimeout(i), (a = 0), (i = n = r = null);
        }),
        c
    );
}
var V = { ltr: ["marginLeft", "marginRight"], rtl: ["marginRight", "marginLeft"] };
function ee(s, t, e) {
    var i = {
        apply: function (r) {
            for (var o = 0, a = r.length; o < a; o++) {
                var l = r[o].style,
                    c = t.Direction.value;
                o !== 0 ? (l[V[c][0]] = "".concat(this.value / 2, "px")) : (l[V[c][0]] = ""),
                    o !== r.length - 1 ? (l[V[c][1]] = "".concat(this.value / 2, "px")) : (l[V[c][1]] = "");
            }
        },
        remove: function (r) {
            for (var o = 0, a = r.length; o < a; o++) {
                var l = r[o].style;
                (l.marginLeft = ""), (l.marginRight = "");
            }
        },
    };
    return (
        g(i, "value", {
            get: function () {
                return b(s.settings.gap);
            },
        }),
        g(i, "grow", {
            get: function () {
                return i.value * t.Sizes.length;
            },
        }),
        g(i, "reductor", {
            get: function () {
                var r = s.settings.perView;
                return (i.value * (r - 1)) / r;
            },
        }),
        e.on(
            ["build.after", "update"],
            j(function () {
                i.apply(t.Html.wrapper.children);
            }, 30)
        ),
        e.on("destroy", function () {
            i.remove(t.Html.wrapper.children);
        }),
        i
    );
}
function _t(s) {
    if (s && s.parentNode) {
        for (var t = s.parentNode.firstChild, e = []; t; t = t.nextSibling) t.nodeType === 1 && t !== s && e.push(t);
        return e;
    }
    return [];
}
function tt(s) {
    return Array.prototype.slice.call(s);
}
var ie = '[data-glide-el="track"]';
function ne(s, t, e) {
    var i = {
        mount: function () {
            (this.root = s.selector), (this.track = this.root.querySelector(ie)), this.collectSlides();
        },
        collectSlides: function () {
            this.slides = tt(this.wrapper.children).filter(function (r) {
                return !r.classList.contains(s.settings.classes.slide.clone);
            });
        },
    };
    return (
        g(i, "root", {
            get: function () {
                return i._r;
            },
            set: function (r) {
                Z(r) && (r = document.querySelector(r)),
                    r !== null ? (i._r = r) : _("Root element must be a existing Html node");
            },
        }),
        g(i, "track", {
            get: function () {
                return i._t;
            },
            set: function (r) {
                i._t = r;
            },
        }),
        g(i, "wrapper", {
            get: function () {
                return i.track.children[0];
            },
        }),
        e.on("update", function () {
            i.collectSlides();
        }),
        i
    );
}
function se(s, t, e) {
    var i = {
        mount: function () {
            this.value = s.settings.peek;
        },
    };
    return (
        g(i, "value", {
            get: function () {
                return i._v;
            },
            set: function (r) {
                M(r) ? ((r.before = b(r.before)), (r.after = b(r.after))) : (r = b(r)), (i._v = r);
            },
        }),
        g(i, "reductor", {
            get: function () {
                var r = i.value,
                    o = s.settings.perView;
                return M(r) ? r.before / o + r.after / o : (r * 2) / o;
            },
        }),
        e.on(["resize", "update"], function () {
            i.mount();
        }),
        i
    );
}
function re(s, t, e) {
    var i = {
        mount: function () {
            this._o = 0;
        },
        make: function () {
            var r = this,
                o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            (this.offset = o),
                e.emit("move", { movement: this.value }),
                t.Transition.after(function () {
                    e.emit("move.after", { movement: r.value });
                });
        },
    };
    return (
        g(i, "offset", {
            get: function () {
                return i._o;
            },
            set: function (r) {
                i._o = yt(r) ? 0 : b(r);
            },
        }),
        g(i, "translate", {
            get: function () {
                return t.Sizes.slideWidth * s.index;
            },
        }),
        g(i, "value", {
            get: function () {
                var r = this.offset,
                    o = this.translate;
                return t.Direction.is("rtl") ? o + r : o - r;
            },
        }),
        e.on(["build.before", "run"], function () {
            i.make();
        }),
        i
    );
}
function oe(s, t, e) {
    var i = {
        setupSlides: function () {
            for (var r = "".concat(this.slideWidth, "px"), o = t.Html.slides, a = 0; a < o.length; a++)
                o[a].style.width = r;
        },
        setupWrapper: function () {
            t.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        remove: function () {
            for (var r = t.Html.slides, o = 0; o < r.length; o++) r[o].style.width = "";
            t.Html.wrapper.style.width = "";
        },
    };
    return (
        g(i, "length", {
            get: function () {
                return t.Html.slides.length;
            },
        }),
        g(i, "width", {
            get: function () {
                return t.Html.track.offsetWidth;
            },
        }),
        g(i, "wrapperSize", {
            get: function () {
                return i.slideWidth * i.length + t.Gaps.grow + t.Clones.grow;
            },
        }),
        g(i, "slideWidth", {
            get: function () {
                return i.width / s.settings.perView - t.Peek.reductor - t.Gaps.reductor;
            },
        }),
        e.on(["build.before", "resize", "update"], function () {
            i.setupSlides(), i.setupWrapper();
        }),
        e.on("destroy", function () {
            i.remove();
        }),
        i
    );
}
function ae(s, t, e) {
    var i = {
        mount: function () {
            e.emit("build.before"), this.typeClass(), this.activeClass(), e.emit("build.after");
        },
        typeClass: function () {
            t.Html.root.classList.add(s.settings.classes.type[s.settings.type]);
        },
        activeClass: function () {
            var r = s.settings.classes,
                o = t.Html.slides[s.index];
            o &&
                (o.classList.add(r.slide.active),
                _t(o).forEach(function (a) {
                    a.classList.remove(r.slide.active);
                }));
        },
        removeClasses: function () {
            var r = s.settings.classes,
                o = r.type,
                a = r.slide;
            t.Html.root.classList.remove(o[s.settings.type]),
                t.Html.slides.forEach(function (l) {
                    l.classList.remove(a.active);
                });
        },
    };
    return (
        e.on(["destroy", "update"], function () {
            i.removeClasses();
        }),
        e.on(["resize", "update"], function () {
            i.mount();
        }),
        e.on("move.after", function () {
            i.activeClass();
        }),
        i
    );
}
function le(s, t, e) {
    var i = {
        mount: function () {
            (this.items = []), s.isType("carousel") && (this.items = this.collect());
        },
        collect: function () {
            var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [],
                o = t.Html.slides,
                a = s.settings,
                l = a.perView,
                c = a.classes,
                d = a.cloningRatio;
            if (o.length > 0)
                for (
                    var u = +!!s.settings.peek,
                        f = l + u + Math.round(l / 2),
                        m = o.slice(0, f).reverse(),
                        p = o.slice(f * -1),
                        v = 0;
                    v < Math.max(d, Math.floor(l / o.length));
                    v++
                ) {
                    for (var S = 0; S < m.length; S++) {
                        var w = m[S].cloneNode(!0);
                        w.classList.add(c.slide.clone), r.push(w);
                    }
                    for (var E = 0; E < p.length; E++) {
                        var T = p[E].cloneNode(!0);
                        T.classList.add(c.slide.clone), r.unshift(T);
                    }
                }
            return r;
        },
        append: function () {
            for (
                var r = this.items,
                    o = t.Html,
                    a = o.wrapper,
                    l = o.slides,
                    c = Math.floor(r.length / 2),
                    d = r.slice(0, c).reverse(),
                    u = r.slice(c * -1).reverse(),
                    f = "".concat(t.Sizes.slideWidth, "px"),
                    m = 0;
                m < u.length;
                m++
            )
                a.appendChild(u[m]);
            for (var p = 0; p < d.length; p++) a.insertBefore(d[p], l[0]);
            for (var v = 0; v < r.length; v++) r[v].style.width = f;
        },
        remove: function () {
            for (var r = this.items, o = 0; o < r.length; o++) t.Html.wrapper.removeChild(r[o]);
        },
    };
    return (
        g(i, "grow", {
            get: function () {
                return (t.Sizes.slideWidth + t.Gaps.value) * i.items.length;
            },
        }),
        e.on("update", function () {
            i.remove(), i.mount(), i.append();
        }),
        e.on("build.before", function () {
            s.isType("carousel") && i.append();
        }),
        e.on("destroy", function () {
            i.remove();
        }),
        i
    );
}
var x = (function () {
    function s() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        F(this, s), (this.listeners = t);
    }
    return (
        U(s, [
            {
                key: "on",
                value: function (e, i, n) {
                    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                    Z(e) && (e = [e]);
                    for (var o = 0; o < e.length; o++)
                        (this.listeners[e[o]] = n), i.addEventListener(e[o], this.listeners[e[o]], r);
                },
            },
            {
                key: "off",
                value: function (e, i) {
                    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                    Z(e) && (e = [e]);
                    for (var r = 0; r < e.length; r++) i.removeEventListener(e[r], this.listeners[e[r]], n);
                },
            },
            {
                key: "destroy",
                value: function () {
                    delete this.listeners;
                },
            },
        ]),
        s
    );
})();
function ce(s, t, e) {
    var i = new x(),
        n = {
            mount: function () {
                this.bind();
            },
            bind: function () {
                i.on(
                    "resize",
                    window,
                    j(function () {
                        e.emit("resize");
                    }, s.settings.throttle)
                );
            },
            unbind: function () {
                i.off("resize", window);
            },
        };
    return (
        e.on("destroy", function () {
            n.unbind(), i.destroy();
        }),
        n
    );
}
var de = ["ltr", "rtl"],
    ue = { ">": "<", "<": ">", "=": "=" };
function he(s, t, e) {
    var i = {
        mount: function () {
            this.value = s.settings.direction;
        },
        resolve: function (r) {
            var o = r.slice(0, 1);
            return this.is("rtl") ? r.split(o).join(ue[o]) : r;
        },
        is: function (r) {
            return this.value === r;
        },
        addClass: function () {
            t.Html.root.classList.add(s.settings.classes.direction[this.value]);
        },
        removeClass: function () {
            t.Html.root.classList.remove(s.settings.classes.direction[this.value]);
        },
    };
    return (
        g(i, "value", {
            get: function () {
                return i._v;
            },
            set: function (r) {
                de.indexOf(r) > -1 ? (i._v = r) : _("Direction value must be `ltr` or `rtl`");
            },
        }),
        e.on(["destroy", "update"], function () {
            i.removeClass();
        }),
        e.on("update", function () {
            i.mount();
        }),
        e.on(["build.before", "update"], function () {
            i.addClass();
        }),
        i
    );
}
function fe(s, t) {
    return {
        modify: function (i) {
            return t.Direction.is("rtl") ? -i : i;
        },
    };
}
function me(s, t) {
    return {
        modify: function (i) {
            var n = Math.floor(i / t.Sizes.slideWidth);
            return i + t.Gaps.value * n;
        },
    };
}
function pe(s, t) {
    return {
        modify: function (i) {
            return i + t.Clones.grow / 2;
        },
    };
}
function ge(s, t) {
    return {
        modify: function (i) {
            if (s.settings.focusAt >= 0) {
                var n = t.Peek.value;
                return M(n) ? i - n.before : i - n;
            }
            return i;
        },
    };
}
function ve(s, t) {
    return {
        modify: function (i) {
            var n = t.Gaps.value,
                r = t.Sizes.width,
                o = s.settings.focusAt,
                a = t.Sizes.slideWidth;
            return o === "center" ? i - (r / 2 - a / 2) : i - a * o - n * o;
        },
    };
}
function be(s, t, e) {
    var i = [me, pe, ge, ve].concat(s._t, [fe]);
    return {
        mutate: function (r) {
            for (var o = 0; o < i.length; o++) {
                var a = i[o];
                N(a) && N(a().modify)
                    ? (r = a(s, t, e).modify(r))
                    : _("Transformer should be a function that returns an object with `modify()` method");
            }
            return r;
        },
    };
}
function ye(s, t, e) {
    var i = {
        set: function (r) {
            var o = be(s, t).mutate(r),
                a = "translate3d(".concat(-1 * o, "px, 0px, 0px)");
            (t.Html.wrapper.style.mozTransform = a),
                (t.Html.wrapper.style.webkitTransform = a),
                (t.Html.wrapper.style.transform = a);
        },
        remove: function () {
            t.Html.wrapper.style.transform = "";
        },
        getStartIndex: function () {
            var r = t.Sizes.length,
                o = s.index,
                a = s.settings.perView;
            return t.Run.isOffset(">") || t.Run.isOffset("|>") ? r + (o - a) : (o + a) % r;
        },
        getTravelDistance: function () {
            var r = t.Sizes.slideWidth * s.settings.perView;
            return t.Run.isOffset(">") || t.Run.isOffset("|>") ? r * -1 : r;
        },
    };
    return (
        e.on("move", function (n) {
            if (!s.isType("carousel") || !t.Run.isOffset()) return i.set(n.movement);
            t.Transition.after(function () {
                e.emit("translate.jump"), i.set(t.Sizes.slideWidth * s.index);
            });
            var r = t.Sizes.slideWidth * t.Translate.getStartIndex();
            return i.set(r - t.Translate.getTravelDistance());
        }),
        e.on("destroy", function () {
            i.remove();
        }),
        i
    );
}
function _e(s, t, e) {
    var i = !1,
        n = {
            compose: function (o) {
                var a = s.settings;
                return i
                    ? "".concat(o, " 0ms ").concat(a.animationTimingFunc)
                    : "".concat(o, " ").concat(this.duration, "ms ").concat(a.animationTimingFunc);
            },
            set: function () {
                var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
                t.Html.wrapper.style.transition = this.compose(o);
            },
            remove: function () {
                t.Html.wrapper.style.transition = "";
            },
            after: function (o) {
                setTimeout(function () {
                    o();
                }, this.duration);
            },
            enable: function () {
                (i = !1), this.set();
            },
            disable: function () {
                (i = !0), this.set();
            },
        };
    return (
        g(n, "duration", {
            get: function () {
                var o = s.settings;
                return s.isType("slider") && t.Run.offset ? o.rewindDuration : o.animationDuration;
            },
        }),
        e.on("move", function () {
            n.set();
        }),
        e.on(["build.before", "resize", "translate.jump"], function () {
            n.disable();
        }),
        e.on("run", function () {
            n.enable();
        }),
        e.on("destroy", function () {
            n.remove();
        }),
        n
    );
}
var St = !1;
try {
    var ht = Object.defineProperty({}, "passive", {
        get: function () {
            St = !0;
        },
    });
    window.addEventListener("testPassive", null, ht), window.removeEventListener("testPassive", null, ht);
} catch {}
var et = St,
    H = ["touchstart", "mousedown"],
    ft = ["touchmove", "mousemove"],
    mt = ["touchend", "touchcancel", "mouseup", "mouseleave"],
    pt = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function Se(s, t, e) {
    var i = new x(),
        n = 0,
        r = 0,
        o = 0,
        a = !1,
        l = et ? { passive: !0 } : !1,
        c = {
            mount: function () {
                this.bindSwipeStart();
            },
            start: function (u) {
                if (!a && !s.disabled) {
                    this.disable();
                    var f = this.touches(u);
                    (n = null),
                        (r = b(f.pageX)),
                        (o = b(f.pageY)),
                        this.bindSwipeMove(),
                        this.bindSwipeEnd(),
                        e.emit("swipe.start");
                }
            },
            move: function (u) {
                if (!s.disabled) {
                    var f = s.settings,
                        m = f.touchAngle,
                        p = f.touchRatio,
                        v = f.classes,
                        S = this.touches(u),
                        w = b(S.pageX) - r,
                        E = b(S.pageY) - o,
                        T = Math.abs(w << 2),
                        rt = Math.abs(E << 2),
                        wt = Math.sqrt(T + rt),
                        Et = Math.sqrt(rt);
                    if (((n = Math.asin(Et / wt)), (n * 180) / Math.PI < m))
                        u.stopPropagation(),
                            t.Move.make(w * Xt(p)),
                            t.Html.root.classList.add(v.dragging),
                            e.emit("swipe.move");
                    else return !1;
                }
            },
            end: function (u) {
                if (!s.disabled) {
                    var f = s.settings,
                        m = f.perSwipe,
                        p = f.touchAngle,
                        v = f.classes,
                        S = this.touches(u),
                        w = this.threshold(u),
                        E = S.pageX - r,
                        T = (n * 180) / Math.PI;
                    this.enable(),
                        E > w && T < p
                            ? t.Run.make(t.Direction.resolve("".concat(m, "<")))
                            : E < -w && T < p
                              ? t.Run.make(t.Direction.resolve("".concat(m, ">")))
                              : t.Move.make(),
                        t.Html.root.classList.remove(v.dragging),
                        this.unbindSwipeMove(),
                        this.unbindSwipeEnd(),
                        e.emit("swipe.end");
                }
            },
            bindSwipeStart: function () {
                var u = this,
                    f = s.settings,
                    m = f.swipeThreshold,
                    p = f.dragThreshold;
                m &&
                    i.on(
                        H[0],
                        t.Html.wrapper,
                        function (v) {
                            u.start(v);
                        },
                        l
                    ),
                    p &&
                        i.on(
                            H[1],
                            t.Html.wrapper,
                            function (v) {
                                u.start(v);
                            },
                            l
                        );
            },
            unbindSwipeStart: function () {
                i.off(H[0], t.Html.wrapper, l), i.off(H[1], t.Html.wrapper, l);
            },
            bindSwipeMove: function () {
                var u = this;
                i.on(
                    ft,
                    t.Html.wrapper,
                    j(function (f) {
                        u.move(f);
                    }, s.settings.throttle),
                    l
                );
            },
            unbindSwipeMove: function () {
                i.off(ft, t.Html.wrapper, l);
            },
            bindSwipeEnd: function () {
                var u = this;
                i.on(mt, t.Html.wrapper, function (f) {
                    u.end(f);
                });
            },
            unbindSwipeEnd: function () {
                i.off(mt, t.Html.wrapper);
            },
            touches: function (u) {
                return pt.indexOf(u.type) > -1 ? u : u.touches[0] || u.changedTouches[0];
            },
            threshold: function (u) {
                var f = s.settings;
                return pt.indexOf(u.type) > -1 ? f.dragThreshold : f.swipeThreshold;
            },
            enable: function () {
                return (a = !1), t.Transition.enable(), this;
            },
            disable: function () {
                return (a = !0), t.Transition.disable(), this;
            },
        };
    return (
        e.on("build.after", function () {
            t.Html.root.classList.add(s.settings.classes.swipeable);
        }),
        e.on("destroy", function () {
            c.unbindSwipeStart(), c.unbindSwipeMove(), c.unbindSwipeEnd(), i.destroy();
        }),
        c
    );
}
function we(s, t, e) {
    var i = new x(),
        n = {
            mount: function () {
                this.bind();
            },
            bind: function () {
                i.on("dragstart", t.Html.wrapper, this.dragstart);
            },
            unbind: function () {
                i.off("dragstart", t.Html.wrapper);
            },
            dragstart: function (o) {
                o.preventDefault();
            },
        };
    return (
        e.on("destroy", function () {
            n.unbind(), i.destroy();
        }),
        n
    );
}
function Ee(s, t, e) {
    var i = new x(),
        n = !1,
        r = !1,
        o = {
            mount: function () {
                (this._a = t.Html.wrapper.querySelectorAll("a")), this.bind();
            },
            bind: function () {
                i.on("click", t.Html.wrapper, this.click);
            },
            unbind: function () {
                i.off("click", t.Html.wrapper);
            },
            click: function (l) {
                r && (l.stopPropagation(), l.preventDefault());
            },
            detach: function () {
                if (((r = !0), !n)) {
                    for (var l = 0; l < this.items.length; l++) this.items[l].draggable = !1;
                    n = !0;
                }
                return this;
            },
            attach: function () {
                if (((r = !1), n)) {
                    for (var l = 0; l < this.items.length; l++) this.items[l].draggable = !0;
                    n = !1;
                }
                return this;
            },
        };
    return (
        g(o, "items", {
            get: function () {
                return o._a;
            },
        }),
        e.on("swipe.move", function () {
            o.detach();
        }),
        e.on("swipe.end", function () {
            t.Transition.after(function () {
                o.attach();
            });
        }),
        e.on("destroy", function () {
            o.attach(), o.unbind(), i.destroy();
        }),
        o
    );
}
var Ce = '[data-glide-el="controls[nav]"]',
    st = '[data-glide-el^="controls"]',
    xe = "".concat(st, ' [data-glide-dir*="<"]'),
    Te = "".concat(st, ' [data-glide-dir*=">"]');
function Ae(s, t, e) {
    var i = new x(),
        n = et ? { passive: !0 } : !1,
        r = {
            mount: function () {
                (this._n = t.Html.root.querySelectorAll(Ce)),
                    (this._c = t.Html.root.querySelectorAll(st)),
                    (this._arrowControls = {
                        previous: t.Html.root.querySelectorAll(xe),
                        next: t.Html.root.querySelectorAll(Te),
                    }),
                    this.addBindings();
            },
            setActive: function () {
                for (var a = 0; a < this._n.length; a++) this.addClass(this._n[a].children);
            },
            removeActive: function () {
                for (var a = 0; a < this._n.length; a++) this.removeClass(this._n[a].children);
            },
            addClass: function (a) {
                var l = s.settings,
                    c = a[s.index];
                c &&
                    (c.classList.add(l.classes.nav.active),
                    _t(c).forEach(function (d) {
                        d.classList.remove(l.classes.nav.active);
                    }));
            },
            removeClass: function (a) {
                var l = a[s.index];
                l?.classList.remove(s.settings.classes.nav.active);
            },
            setArrowState: function () {
                if (!s.settings.rewind) {
                    var a = r._arrowControls.next,
                        l = r._arrowControls.previous;
                    this.resetArrowState(a, l),
                        s.index === 0 && this.disableArrow(l),
                        s.index === t.Run.length && this.disableArrow(a);
                }
            },
            resetArrowState: function () {
                for (var a = s.settings, l = arguments.length, c = new Array(l), d = 0; d < l; d++) c[d] = arguments[d];
                c.forEach(function (u) {
                    tt(u).forEach(function (f) {
                        f.classList.remove(a.classes.arrow.disabled);
                    });
                });
            },
            disableArrow: function () {
                for (var a = s.settings, l = arguments.length, c = new Array(l), d = 0; d < l; d++) c[d] = arguments[d];
                c.forEach(function (u) {
                    tt(u).forEach(function (f) {
                        f.classList.add(a.classes.arrow.disabled);
                    });
                });
            },
            addBindings: function () {
                for (var a = 0; a < this._c.length; a++) this.bind(this._c[a].children);
            },
            removeBindings: function () {
                for (var a = 0; a < this._c.length; a++) this.unbind(this._c[a].children);
            },
            bind: function (a) {
                for (var l = 0; l < a.length; l++)
                    i.on("click", a[l], this.click), i.on("touchstart", a[l], this.click, n);
            },
            unbind: function (a) {
                for (var l = 0; l < a.length; l++) i.off(["click", "touchstart"], a[l]);
            },
            click: function (a) {
                !et && a.type === "touchstart" && a.preventDefault();
                var l = a.currentTarget.getAttribute("data-glide-dir");
                t.Run.make(t.Direction.resolve(l));
            },
        };
    return (
        g(r, "items", {
            get: function () {
                return r._c;
            },
        }),
        e.on(["mount.after", "move.after"], function () {
            r.setActive();
        }),
        e.on(["mount.after", "run"], function () {
            r.setArrowState();
        }),
        e.on("destroy", function () {
            r.removeBindings(), r.removeActive(), i.destroy();
        }),
        r
    );
}
function Le(s, t, e) {
    var i = new x(),
        n = {
            mount: function () {
                s.settings.keyboard && this.bind();
            },
            bind: function () {
                i.on("keyup", document, this.press);
            },
            unbind: function () {
                i.off("keyup", document);
            },
            press: function (o) {
                var a = s.settings.perSwipe,
                    l = { ArrowRight: ">", ArrowLeft: "<" };
                ["ArrowRight", "ArrowLeft"].includes(o.code) &&
                    t.Run.make(t.Direction.resolve("".concat(a).concat(l[o.code])));
            },
        };
    return (
        e.on(["destroy", "update"], function () {
            n.unbind();
        }),
        e.on("update", function () {
            n.mount();
        }),
        e.on("destroy", function () {
            i.destroy();
        }),
        n
    );
}
function ke(s, t, e) {
    var i = new x(),
        n = {
            mount: function () {
                this.enable(), this.start(), s.settings.hoverpause && this.bind();
            },
            enable: function () {
                this._e = !0;
            },
            disable: function () {
                this._e = !1;
            },
            start: function () {
                var o = this;
                this._e &&
                    (this.enable(),
                    s.settings.autoplay &&
                        yt(this._i) &&
                        (this._i = setInterval(function () {
                            o.stop(), t.Run.make(">"), o.start(), e.emit("autoplay");
                        }, this.time)));
            },
            stop: function () {
                this._i = clearInterval(this._i);
            },
            bind: function () {
                var o = this;
                i.on("mouseover", t.Html.root, function () {
                    o._e && o.stop();
                }),
                    i.on("mouseout", t.Html.root, function () {
                        o._e && o.start();
                    });
            },
            unbind: function () {
                i.off(["mouseover", "mouseout"], t.Html.root);
            },
        };
    return (
        g(n, "time", {
            get: function () {
                var o = t.Html.slides[s.index].getAttribute("data-glide-autoplay");
                return b(o || s.settings.autoplay);
            },
        }),
        e.on(["destroy", "update"], function () {
            n.unbind();
        }),
        e.on(["run.before", "swipe.start", "update"], function () {
            n.stop();
        }),
        e.on(["pause", "destroy"], function () {
            n.disable(), n.stop();
        }),
        e.on(["run.after", "swipe.end"], function () {
            n.start();
        }),
        e.on(["play"], function () {
            n.enable(), n.start();
        }),
        e.on("update", function () {
            n.mount();
        }),
        e.on("destroy", function () {
            i.destroy();
        }),
        n
    );
}
function gt(s) {
    return M(s) ? Zt(s) : (_("Breakpoints option must be an object"), {});
}
function Ie(s, t, e) {
    var i = new x(),
        n = s.settings,
        r = gt(n.breakpoints),
        o = Object.assign({}, n),
        a = {
            match: function (c) {
                if (typeof window.matchMedia < "u") {
                    for (var d in c)
                        if (c.hasOwnProperty(d) && window.matchMedia("(max-width: ".concat(d, "px)")).matches)
                            return c[d];
                }
                return o;
            },
        };
    return (
        Object.assign(n, a.match(r)),
        i.on(
            "resize",
            window,
            j(function () {
                s.settings = G(n, a.match(r));
            }, s.settings.throttle)
        ),
        e.on("update", function () {
            (r = gt(r)), (o = Object.assign({}, n));
        }),
        e.on("destroy", function () {
            i.off("resize", window);
        }),
        a
    );
}
var Me = {
        Html: ne,
        Translate: ye,
        Transition: _e,
        Direction: he,
        Peek: se,
        Sizes: oe,
        Gaps: ee,
        Move: re,
        Clones: le,
        Resize: ce,
        Build: ae,
        Run: te,
        Swipe: Se,
        Images: we,
        Anchors: Ee,
        Controls: Ae,
        Keyboard: Le,
        Autoplay: ke,
        Breakpoints: Ie,
    },
    Re = (function (s) {
        zt(e, s);
        var t = Wt(e);
        function e() {
            return F(this, e), t.apply(this, arguments);
        }
        return (
            U(e, [
                {
                    key: "mount",
                    value: function () {
                        var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                        return $(I(e.prototype), "mount", this).call(this, Object.assign({}, Me, n));
                    },
                },
            ]),
            e
        );
    })(Gt);
const Pe = {
    type: "slider",
    startAt: 0,
    gap: 16,
    autoplay: !1,
    hoverpause: !0,
    keyboard: !0,
    bound: !1,
    swipeThreshold: 80,
    dragThreshold: 120,
    touchRatio: 0.5,
    touchAngle: 45,
    animationDuration: 400,
    animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    direction: "ltr",
};
class z {
    constructor(t, e) {
        (this.glide = null),
            (this.isDestroyed = !1),
            (this.navigationButtons = {}),
            (this.container = t),
            (this.config = {
                selector: e.selector,
                options: { ...Pe, ...e.options },
                onInit: e.onInit,
                onDestroy: e.onDestroy,
            }),
            this.init();
    }
    init() {
        try {
            const t = this.container.querySelector(this.config.selector);
            if (!t) {
                h(`Glide: Element not found with selector: ${this.config.selector}`, "error");
                return;
            }
            h("Initializing Glide", "info", { element: t, options: this.config.options }),
                (this.glide = new Re(t, this.config.options)),
                this.setupEventListeners();
            try {
                this.glide.mount(),
                    h("Glide mounted successfully", "info"),
                    this.setupNavigation(),
                    this.config.onInit?.(this.getPublicInstance());
            } catch (e) {
                h("Error mounting Glide carousel", "error", e);
            }
        } catch (t) {
            h("Error initializing Glide", "error", t);
        }
    }
    setupEventListeners() {
        if (!this.glide) return;
        let t;
        const e = () => {
            window.clearTimeout(t),
                (t = window.setTimeout(() => {
                    this.glide && !this.isDestroyed && this.glide.update();
                }, 250));
        };
        window.addEventListener("resize", e, { passive: !0 }),
            this.glide.on("destroy", () => {
                window.removeEventListener("resize", e), (this.isDestroyed = !0), this.config.onDestroy?.();
            });
    }
    setupNavigation() {
        if (!this.glide) return;
        const t = this.container.querySelector(".carousel-btn--prev"),
            e = this.container.querySelector(".carousel-btn--next");
        t &&
            e &&
            ((this.navigationButtons = { prev: t, next: e }),
            t.addEventListener("click", () => this.glide?.go("<")),
            e.addEventListener("click", () => this.glide?.go(">")),
            this.glide.on("move", () => {
                this.updateNavigationState();
            }),
            window.setTimeout(() => {
                this.updateNavigationState();
            }, 0));
    }
    updateNavigationState() {
        if (!this.glide || !this.navigationButtons.prev || !this.navigationButtons.next) return;
        const t = this.glide.index,
            e = this.glide.settings.perView
                ? Math.ceil(this.container.querySelectorAll(".glide__slide").length / this.glide.settings.perView)
                : this.container.querySelectorAll(".glide__slide").length,
            i = t === 0,
            n = t >= e - 1;
        this.navigationButtons.prev.toggleAttribute("disabled", i),
            this.navigationButtons.next.toggleAttribute("disabled", n);
    }
    getPublicInstance() {
        const t = this.glide;
        return {
            mount: () => t?.mount(),
            destroy: () => this.destroy(),
            go: (e) => t?.go(e.toString()),
            update: (e) => t?.update(e),
            on: (e, i) => t?.on(e, i),
            get index() {
                return t?.index || 0;
            },
            get settings() {
                return t?.settings || {};
            },
        };
    }
    destroy() {
        this.glide && !this.isDestroyed && (this.glide.destroy(), (this.glide = null));
    }
    refresh() {
        this.glide?.update();
    }
    goTo(t) {
        this.glide?.go(t.toString());
    }
    getInstance() {
        return this.glide;
    }
    isActive() {
        return !!this.glide && !this.isDestroyed;
    }
    static create(t, e) {
        return new z(t, e);
    }
    static initializeAll(t, e) {
        const i = document.querySelectorAll(t),
            n = [];
        return (
            i.forEach((r) => {
                const o = new z(r, { ...e, selector: ".glide" });
                n.push(o);
            }),
            n
        );
    }
}
class Be extends C {
    constructor(t) {
        super(t), (this.componentName = "CollectionGridEnhanced"), (this.carousel = null);
    }
    getDefaultConfig() {
        return { isCarousel: !1, desktopColumns: 3, mobileColumns: 1, loopEnabled: !1, debug: !1 };
    }
    init() {
        this.extractConfigFromAttributes(),
            this.cacheElements() &&
                window.setTimeout(() => {
                    this.initializeCarousel(),
                        this.initializeProductCards(),
                        this.initializeScrollAnimations(),
                        this.log("Component initialized");
                }, 300);
    }
    extractConfigFromAttributes() {
        const t = this.container.dataset;
        (this.config = {
            ...this.config,
            isCarousel: t.carousel === "true",
            desktopColumns: parseFloat(t.desktopColumns || "3"),
            mobileColumns: parseFloat(t.mobileColumns || "1"),
            loopEnabled: t.carouselLoop === "true",
        }),
            this.log(`Config: carousel=${this.config.isCarousel}, desktopColumns=${this.config.desktopColumns}`);
    }
    cacheElements() {
        return (
            (this.elements = L(this.container, {
                glideElement: ".glide",
                productCards: ".product-card",
                gridContainer: ".collection-grid",
            })),
            this.config.isCarousel && !this.elements.glideElement
                ? (this.log("Carousel mode enabled but glide element not found", "error"), !1)
                : !0
        );
    }
    initializeCarousel() {
        if (!this.config.isCarousel) {
            this.log("Carousel disabled, using grid layout");
            return;
        }
        if (y(this.elements.glideElement, "Glide element not found"))
            try {
                (this.carousel = new z(this.container, {
                    selector: ".glide",
                    options: {
                        perView: this.config.desktopColumns,
                        gap: 20,
                        rewind: this.config.loopEnabled,
                        peek: { before: 0, after: 50 },
                        breakpoints: {
                            [nt.md]: { perView: this.config.mobileColumns, gap: 15, peek: { before: 0, after: 30 } },
                        },
                    },
                })),
                    this.log("Carousel initialized successfully");
            } catch (t) {
                this.log(`Failed to initialize carousel: ${t}`, "error");
            }
    }
    initializeProductCards() {
        const t = this.container.querySelectorAll(".product-card");
        if (t.length === 0) {
            this.log("No product cards found", "warn");
            return;
        }
        this.log(`Initialized ${t.length} product cards`);
    }
    initializeScrollAnimations() {
        this.log("Scroll animations handled by CSS");
    }
    getCarousel() {
        return this.carousel;
    }
    isCarouselMode() {
        return this.config.isCarousel;
    }
    destroy() {
        this.isDestroyed() ||
            (this.carousel && (this.carousel.destroy(), (this.carousel = null)),
            super.destroy(),
            this.log("Component destroyed"));
    }
}
const Oe = 100,
    De = 5e3;
class Ve extends C {
    constructor(t) {
        super(t),
            (this.componentName = "TestimonialCarousel"),
            (this.prefersReducedMotion = !1),
            (this.currentSlideIndex = 0),
            (this.autoplayTimer = null),
            (this.isPaused = !1),
            (this.isProgrammaticScroll = !1),
            (this.itemCount = 0);
    }
    getDefaultConfig() {
        return { autoScroll: !0, scrollSpeed: 30, pauseOnHover: !0, debug: !1 };
    }
    init() {
        this.extractConfigFromAttributes(),
            this.checkReducedMotion(),
            this.cacheElements() &&
                (this.countItems(),
                this.setupEventListeners(),
                this.updateNavigationState(),
                this.startAutoplay(),
                this.log("Component initialized"));
    }
    extractConfigFromAttributes() {
        const t = this.container.dataset;
        this.config = {
            ...this.config,
            autoScroll: t.autoScroll !== "false",
            scrollSpeed: parseInt(t.scrollSpeed || "30", 10),
            pauseOnHover: t.pauseOnHover !== "false",
        };
    }
    checkReducedMotion() {
        this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    cacheElements() {
        return (
            (this.elements = L(this.container, {
                trackWrapper: ".testimonial-carousel__track-wrapper",
                track: "[data-carousel-track]",
                items: ".testimonial-carousel__item",
                prevBtn: "[data-prev]",
                nextBtn: "[data-next]",
            })),
            !(
                !y(this.elements.trackWrapper, "[TestimonialCarousel] Track wrapper not found") ||
                !y(this.elements.track, "[TestimonialCarousel] Track element not found")
            )
        );
    }
    countItems() {
        if (!this.elements.track) return;
        const t = this.elements.track.querySelectorAll(".testimonial-carousel__item");
        this.itemCount = t.length;
    }
    setupEventListeners() {
        this.elements.trackWrapper &&
            ((this.boundScrollHandler = k(this.handleScroll.bind(this), Oe)),
            this.elements.trackWrapper.addEventListener("scroll", this.boundScrollHandler, { passive: !0 }),
            this.config.pauseOnHover &&
                this.config.autoScroll &&
                ((this.boundMouseEnter = this.pauseAutoplay.bind(this)),
                (this.boundMouseLeave = this.resumeAutoplay.bind(this)),
                this.container.addEventListener("mouseenter", this.boundMouseEnter),
                this.container.addEventListener("mouseleave", this.boundMouseLeave)),
            this.elements.prevBtn &&
                ((this.boundPrevClick = this.scrollPrev.bind(this)),
                this.elements.prevBtn.addEventListener("click", this.boundPrevClick)),
            this.elements.nextBtn &&
                ((this.boundNextClick = this.scrollNext.bind(this)),
                this.elements.nextBtn.addEventListener("click", this.boundNextClick)),
            (this.boundVisibilityChange = this.handleVisibilityChange.bind(this)),
            document.addEventListener("visibilitychange", this.boundVisibilityChange));
    }
    handleVisibilityChange() {
        document.hidden
            ? this.stopAutoplay()
            : this.config.autoScroll && !this.prefersReducedMotion && this.itemCount > 1 && this.startAutoplay();
    }
    startAutoplay() {
        !this.config.autoScroll ||
            this.prefersReducedMotion ||
            this.itemCount <= 1 ||
            ((this.autoplayTimer = window.setInterval(() => {
                this.isPaused || this.scrollToNextItem();
            }, De)),
            this.log("Autoplay started"));
    }
    stopAutoplay() {
        this.autoplayTimer &&
            (window.clearInterval(this.autoplayTimer), (this.autoplayTimer = null), this.log("Autoplay stopped"));
    }
    pauseAutoplay() {
        (this.isPaused = !0), this.log("Autoplay paused");
    }
    resumeAutoplay() {
        (this.isPaused = !1), this.log("Autoplay resumed");
    }
    scrollToNextItem() {
        const t = (this.currentSlideIndex + 1) % this.itemCount;
        this.scrollToSlide(t);
    }
    scrollPrev() {
        this.currentSlideIndex <= 0 || this.scrollToSlide(this.currentSlideIndex - 1);
    }
    scrollNext() {
        this.currentSlideIndex >= this.itemCount - 1 || this.scrollToSlide(this.currentSlideIndex + 1);
    }
    scrollToSlide(t) {
        if (!this.elements.trackWrapper || !this.elements.track) return;
        const e = this.elements.track.querySelectorAll(".testimonial-carousel__item");
        if (t < 0 || t >= e.length) return;
        const n = e[t].offsetLeft;
        (this.isProgrammaticScroll = !0),
            this.elements.trackWrapper.scrollTo({
                left: n,
                behavior: this.prefersReducedMotion ? "instant" : "smooth",
            }),
            (this.currentSlideIndex = t),
            this.updateNavigationState(),
            window.setTimeout(() => {
                this.isProgrammaticScroll = !1;
            }, 500),
            this.log(`Scrolled to slide ${t}`);
    }
    handleScroll() {
        if (this.isProgrammaticScroll || !this.elements.trackWrapper || !this.elements.track) return;
        const t = this.elements.track.querySelectorAll(".testimonial-carousel__item");
        if (t.length === 0) return;
        const e = this.elements.trackWrapper.scrollLeft;
        let i = 0,
            n = 1 / 0;
        t.forEach((r, o) => {
            const a = Math.abs(r.offsetLeft - e);
            a < n && ((n = a), (i = o));
        }),
            i !== this.currentSlideIndex && ((this.currentSlideIndex = i), this.updateNavigationState());
    }
    updateNavigationState() {
        const t = this.elements.prevBtn,
            e = this.elements.nextBtn;
        t &&
            ((t.disabled = this.currentSlideIndex === 0),
            t.setAttribute("aria-disabled", String(this.currentSlideIndex === 0))),
            e &&
                ((e.disabled = this.currentSlideIndex >= this.itemCount - 1),
                e.setAttribute("aria-disabled", String(this.currentSlideIndex >= this.itemCount - 1)));
    }
    selectBlock(t) {
        if ((this.log(`Block selected: ${t}`), this.pauseAutoplay(), !this.elements.track)) return;
        const e = this.elements.track.querySelectorAll(".testimonial-carousel__item"),
            i = Array.from(e).findIndex((n) => n.dataset.blockId === t);
        i !== -1 && (this.scrollToSlide(i), e[i].classList.add("is-selected"));
    }
    deselectBlock(t) {
        this.log(`Block deselected: ${t}`);
        const e = this.container.querySelector(`[data-block-id="${t}"]`);
        e && e.classList.remove("is-selected"), this.resumeAutoplay();
    }
    destroy() {
        this.isDestroyed() ||
            (this.stopAutoplay(),
            this.elements.trackWrapper &&
                this.boundScrollHandler &&
                this.elements.trackWrapper.removeEventListener("scroll", this.boundScrollHandler),
            this.boundMouseEnter && this.container.removeEventListener("mouseenter", this.boundMouseEnter),
            this.boundMouseLeave && this.container.removeEventListener("mouseleave", this.boundMouseLeave),
            this.elements.prevBtn &&
                this.boundPrevClick &&
                this.elements.prevBtn.removeEventListener("click", this.boundPrevClick),
            this.elements.nextBtn &&
                this.boundNextClick &&
                this.elements.nextBtn.removeEventListener("click", this.boundNextClick),
            this.boundVisibilityChange && document.removeEventListener("visibilitychange", this.boundVisibilityChange),
            super.destroy(),
            this.log("Component destroyed"));
    }
}
const He = 100;
class qe extends C {
    constructor(t) {
        super(t),
            (this.componentName = "ExploreTabs"),
            (this.activeTabIndex = 0),
            (this.isMobile = !1),
            (this.autoScrollInterval = null),
            (this.isProgrammaticScroll = !1),
            (this.cachedTabs = null),
            (this.cachedPanels = null),
            (this.cachedSlides = null),
            (this.cachedDots = null),
            (this.cachedSlidesContainer = null);
    }
    getDefaultConfig() {
        return { autoScroll: !1, scrollSpeed: 5, enableMobileCarousel: !0, debug: !1 };
    }
    init() {
        (this.tabStates = new Map()),
            this.extractConfigFromAttributes(),
            this.cacheElementsAndSetup() &&
                (this.cacheNodeLists(),
                (this.boundResizeHandler = k(this.handleResize.bind(this), He)),
                (this.boundScrollHandler = k(this.handleMobileScroll.bind(this), 50)),
                (this.boundKeyHandler = this.handleKeydown.bind(this)),
                (this.boundTabClick = this.handleTabClick.bind(this)),
                (this.boundDotClick = this.handleDotClick.bind(this)),
                (this.boundVisibilityChange = this.handleVisibilityChange.bind(this)),
                this.detectMobile(),
                this.initializeTabs(),
                this.setupEventListeners(),
                this.updateIndicator(),
                this.config.autoScroll && this.isMobile && this.startAutoScroll(),
                this.log("Component initialized"));
    }
    cacheNodeLists() {
        (this.cachedTabs = this.container.querySelectorAll(".explore-tabs__tab")),
            (this.cachedPanels = this.container.querySelectorAll(".explore-tabs__panel")),
            (this.cachedSlides = this.container.querySelectorAll(".explore-tabs__slide")),
            (this.cachedDots = this.container.querySelectorAll(".explore-tabs__dot")),
            (this.cachedSlidesContainer = this.container.querySelector(".explore-tabs__slides"));
    }
    extractConfigFromAttributes() {
        const t = this.container.dataset;
        this.config = {
            ...this.config,
            autoScroll: t.autoScroll === "true",
            scrollSpeed: parseInt(t.scrollSpeed || "5", 10),
            enableMobileCarousel: t.enableMobileCarousel !== "false",
        };
    }
    cacheElementsAndSetup() {
        return (
            (this.elements = L(this.container, {
                header: ".explore-tabs__header",
                navTrack: ".explore-tabs__nav-track",
                tabs: ".explore-tabs__tab",
                indicator: ".explore-tabs__indicator",
                panelsDesktop: ".explore-tabs__panels-desktop",
                panels: ".explore-tabs__panel",
                panelsMobile: ".explore-tabs__panels-mobile",
                slides: ".explore-tabs__slide",
                slidesContainer: ".explore-tabs__slides",
                dots: ".explore-tabs__dot",
            })),
            !!y(this.elements.navTrack, "[ExploreTabs] Nav track not found")
        );
    }
    detectMobile() {
        this.isMobile = window.innerWidth < nt.lg;
    }
    initializeTabs() {
        !this.cachedTabs ||
            !this.cachedPanels ||
            this.cachedTabs.forEach((t, e) => {
                const i = this.cachedPanels?.[e] ?? null,
                    n = { index: e, id: t.id, tabElement: t, panelElement: i };
                this.tabStates.set(e, n);
            });
    }
    setupEventListeners() {
        window.addEventListener("resize", this.boundResizeHandler);
        const t = this.elements.navTrack;
        t && (t.addEventListener("click", this.boundTabClick), t.addEventListener("keydown", this.boundKeyHandler)),
            this.cachedSlidesContainer &&
                this.cachedSlidesContainer.addEventListener("scroll", this.boundScrollHandler, { passive: !0 });
        const e = this.container.querySelector(".explore-tabs__dots");
        e && e.addEventListener("click", this.boundDotClick),
            document.addEventListener("visibilitychange", this.boundVisibilityChange);
    }
    handleTabClick(t) {
        const e = t.target.closest(".explore-tabs__tab");
        if (!e || !this.cachedTabs) return;
        const i = Array.from(this.cachedTabs).indexOf(e);
        i >= 0 && this.selectTab(i);
    }
    handleDotClick(t) {
        const e = t.target.closest(".explore-tabs__dot");
        if (!e || !this.cachedDots) return;
        const i = Array.from(this.cachedDots).indexOf(e);
        i >= 0 && this.navigateToSlide(i);
    }
    handleVisibilityChange() {
        document.hidden ? this.stopAutoScroll() : this.config.autoScroll && this.isMobile && this.startAutoScroll();
    }
    navigateToSlide(t) {
        t !== this.activeTabIndex && (this.scrollToSlide(t), this.syncTabFromSlide(t));
    }
    handleKeydown(t) {
        if (!this.cachedTabs) return;
        const e = this.cachedTabs.length;
        if (e === 0) return;
        let i = this.activeTabIndex;
        switch (t.key) {
            case "ArrowLeft":
                t.preventDefault(), (i = this.activeTabIndex > 0 ? this.activeTabIndex - 1 : e - 1);
                break;
            case "ArrowRight":
                t.preventDefault(), (i = this.activeTabIndex < e - 1 ? this.activeTabIndex + 1 : 0);
                break;
            case "Home":
                t.preventDefault(), (i = 0);
                break;
            case "End":
                t.preventDefault(), (i = e - 1);
                break;
            default:
                return;
        }
        i !== this.activeTabIndex && (this.selectTab(i), this.cachedTabs[i]?.focus());
    }
    selectTab(t) {
        if (this.checkDestroyed() || t === this.activeTabIndex) return;
        const e = this.tabStates.get(this.activeTabIndex),
            i = this.tabStates.get(t);
        i &&
            (e &&
                (e.tabElement.classList.remove("is-active"),
                e.tabElement.setAttribute("aria-selected", "false"),
                e.tabElement.setAttribute("tabindex", "-1"),
                e.panelElement &&
                    (e.panelElement.classList.remove("is-active"), e.panelElement.setAttribute("hidden", ""))),
            i.tabElement.classList.add("is-active"),
            i.tabElement.setAttribute("aria-selected", "true"),
            i.tabElement.setAttribute("tabindex", "0"),
            i.panelElement && (i.panelElement.classList.add("is-active"), i.panelElement.removeAttribute("hidden")),
            (this.activeTabIndex = t),
            this.updateIndicator(),
            this.updateDots(t),
            this.isMobile && this.scrollToSlide(t),
            this.log(`Tab selected: ${t}`));
    }
    updateIndicator() {
        const t = this.elements.indicator,
            e = this.tabStates.get(this.activeTabIndex)?.tabElement;
        if (!t || !e) return;
        const i = this.elements.navTrack;
        if (!i) return;
        const n = i.getBoundingClientRect(),
            r = e.getBoundingClientRect(),
            o = r.left - n.left + i.scrollLeft,
            a = r.width;
        (t.style.transform = `translateX(${o}px)`), (t.style.width = `${a}px`);
    }
    scrollToSlide(t) {
        if (!this.cachedSlidesContainer || !this.cachedSlides || t < 0 || t >= this.cachedSlides.length) return;
        const e = this.cachedSlides[t],
            i = this.cachedSlidesContainer.getBoundingClientRect(),
            n = e.getBoundingClientRect(),
            r = this.cachedSlidesContainer.scrollLeft + (n.left - i.left) - i.width / 2 + n.width / 2;
        (this.isProgrammaticScroll = !0),
            this.cachedSlidesContainer.scrollTo({ left: Math.max(0, r), behavior: "smooth" }),
            window.setTimeout(() => {
                this.isProgrammaticScroll = !1;
            }, 500);
    }
    handleMobileScroll() {
        if (
            this.isProgrammaticScroll ||
            !this.cachedSlidesContainer ||
            !this.cachedSlides ||
            this.cachedSlides.length === 0
        )
            return;
        const t = this.cachedSlidesContainer.getBoundingClientRect(),
            e = t.left + t.width / 2;
        let i = 0,
            n = 1 / 0;
        this.cachedSlides.forEach((r, o) => {
            const a = r.getBoundingClientRect(),
                l = a.left + a.width / 2,
                c = Math.abs(l - e);
            c < n && ((n = c), (i = o));
        }),
            i !== this.activeTabIndex && this.syncTabFromSlide(i);
    }
    syncTabFromSlide(t) {
        !this.cachedTabs ||
            !this.cachedPanels ||
            (this.cachedTabs.forEach((e, i) => {
                const n = i === t;
                e.classList.toggle("is-active", n), e.setAttribute("aria-selected", n ? "true" : "false");
            }),
            this.cachedPanels.forEach((e, i) => {
                const n = i === t;
                e.classList.toggle("is-active", n), n ? e.removeAttribute("hidden") : e.setAttribute("hidden", "");
            }),
            (this.activeTabIndex = t),
            this.updateIndicator(),
            this.updateDots(t));
    }
    updateDots(t) {
        this.cachedDots &&
            this.cachedDots.forEach((e, i) => {
                e.setAttribute("aria-current", i === t ? "true" : "false");
            });
    }
    handleResize() {
        if (this.checkDestroyed()) return;
        const t = this.isMobile;
        this.detectMobile(),
            this.updateIndicator(),
            t !== this.isMobile &&
                (this.isMobile && this.config.autoScroll ? this.startAutoScroll() : this.stopAutoScroll());
    }
    startAutoScroll() {
        if (this.autoScrollInterval || !this.cachedSlides || this.cachedSlides.length === 0) return;
        const t = (this.config.scrollSpeed || 5) * 1e3,
            e = this.cachedSlides.length;
        this.autoScrollInterval = window.setInterval(() => {
            if (this.checkDestroyed()) {
                this.stopAutoScroll();
                return;
            }
            const i = (this.activeTabIndex + 1) % e;
            this.scrollToSlide(i), this.syncTabFromSlide(i);
        }, t);
    }
    stopAutoScroll() {
        this.autoScrollInterval && (window.clearInterval(this.autoScrollInterval), (this.autoScrollInterval = null));
    }
    selectBlock(t) {
        if (!this.cachedSlides) return;
        let e = -1;
        this.cachedSlides.forEach((i, n) => {
            i.dataset.blockId === t && (e = n);
        }),
            e >= 0 && this.selectTab(e);
    }
    deselectBlock(t) {
        this.log(`Block deselected: ${t}`);
    }
    destroy() {
        if (this.isDestroyed()) return;
        this.stopAutoScroll(),
            window.removeEventListener("resize", this.boundResizeHandler),
            document.removeEventListener("visibilitychange", this.boundVisibilityChange);
        const t = this.elements.navTrack;
        t &&
            (t.removeEventListener("click", this.boundTabClick),
            t.removeEventListener("keydown", this.boundKeyHandler)),
            this.cachedSlidesContainer &&
                this.cachedSlidesContainer.removeEventListener("scroll", this.boundScrollHandler);
        const e = this.container.querySelector(".explore-tabs__dots");
        e && e.removeEventListener("click", this.boundDotClick),
            (this.cachedTabs = null),
            (this.cachedPanels = null),
            (this.cachedSlides = null),
            (this.cachedDots = null),
            (this.cachedSlidesContainer = null),
            this.tabStates.clear(),
            super.destroy(),
            this.log("Component destroyed");
    }
}
class $e extends C {
    constructor(t) {
        super(t),
            (this.componentName = "HeroSlider"),
            (this.slides = []),
            (this.currentIndex = 0),
            (this.autoplayTimer = null),
            (this.isTransitioning = !1),
            (this.abortController = null);
    }
    getDefaultConfig() {
        return { autoplay: !0, loop: !0, autoplayDelay: 5e3, transitionDuration: 600, debug: !1 };
    }
    init() {
        this.cacheElementsAndConfig() &&
            ((this.abortController = new AbortController()),
            this.findSlides(),
            this.setupEvents(),
            this.showSlide(0, !1),
            this.startAutoplay(),
            this.log("Hero slider initialized"));
    }
    cacheElementsAndConfig() {
        if (
            ((this.elements = L(this.container, {
                track: "[data-slider-track]",
                slides: ".hero-slider__slide",
                prevButton: "[data-slider-prev]",
                nextButton: "[data-slider-next]",
            })),
            !y(this.elements.track, "[HeroSlider] Track element not found"))
        )
            return !1;
        const t = this.container.dataset || {};
        return (
            (this.config = {
                ...this.config,
                autoplay: t.autoplay === "true",
                loop: t.loop === "true",
                autoplayDelay: parseInt(t.autoplayDelay || "5000"),
                transitionDuration: parseInt(t.transitionDuration || "600"),
            }),
            !0
        );
    }
    findSlides() {
        if (!this.elements.track) return;
        const t = Array.from(this.elements.track.querySelectorAll(".hero-slider__slide"));
        (this.slides = t.map((e) => {
            const i = e.dataset.slideType || "image";
            let n = null,
                r = null;
            return (
                i === "video" &&
                    e.querySelectorAll(".hero-slider__video-container").forEach((a) => {
                        const l = a.querySelector("video-media");
                        if (l) {
                            const c = l.querySelector("template");
                            if (c) {
                                const d = c.content,
                                    u = d.querySelector("video"),
                                    f = d.querySelector("iframe");
                                u && !n && (n = u), f && !r && (r = f);
                            }
                        }
                    }),
                { slide: e, video: n, iframe: r, type: i }
            );
        })),
            this.log(`Found ${this.slides.length} slides`);
    }
    setupEvents() {
        if (!this.abortController) return;
        const { signal: t } = this.abortController;
        this.elements.prevButton &&
            this.elements.prevButton.addEventListener("click", () => this.prevSlide(), { signal: t }),
            this.elements.nextButton &&
                this.elements.nextButton.addEventListener("click", () => this.nextSlide(), { signal: t }),
            this.slides.forEach(({ slide: e }, i) => {
                e.dataset.slideType === "video" &&
                    (e.querySelectorAll("video-media").forEach((o) => {
                        o.addEventListener("click", () => this.handleVideoClick(i), { signal: t });
                    }),
                    e.querySelectorAll("video").forEach((o) => {
                        o.addEventListener("ended", () => this.handleVideoEnded(i), { signal: t }),
                            o.addEventListener("play", () => this.pauseAutoplay(), { signal: t });
                    }));
            }),
            this.container.addEventListener(
                "mouseenter",
                () => {
                    this.pauseAutoplay();
                },
                { signal: t, passive: !0 }
            ),
            this.container.addEventListener(
                "mouseleave",
                () => {
                    this.resumeAutoplay();
                },
                { signal: t, passive: !0 }
            ),
            document.addEventListener(
                "visibilitychange",
                () => {
                    document.hidden ? (this.pauseAutoplay(), this.pauseCurrentVideo()) : this.resumeAutoplay();
                },
                { signal: t }
            );
    }
    showSlide(t, e = !0) {
        if (this.isTransitioning || !this.slides.length) return;
        const i = this.getValidIndex(t);
        if (i === this.currentIndex && e) return;
        (this.isTransitioning = !0),
            (this.currentIndex = i),
            this.slides.forEach(({ slide: r }, o) => {
                r.classList.toggle("is-active", o === i),
                    (r.style.opacity = o === i ? "1" : "0"),
                    (r.style.visibility = o === i ? "visible" : "hidden");
            }),
            this.updateNavigationState(),
            this.slides[i].type === "video" ? this.loadAndPlayVideo(i) : this.startImageAutoplay(),
            window.setTimeout(() => {
                this.isTransitioning = !1;
            }, this.config.transitionDuration),
            this.log(`Showing slide ${i}`);
    }
    async loadAndPlayVideo(t) {
        const e = this.slides[t];
        if (!e || e.type !== "video") return;
        const i = e.slide.querySelectorAll(".hero-slider__video-container"),
            n = Array.from(i).find((c) => window.getComputedStyle(c).display !== "none");
        if (!n) return;
        const r = n.querySelector("video-media");
        if (!r) return;
        const o = r.querySelector("template");
        if (o) {
            const c = o.content.cloneNode(!0);
            o.replaceWith(c), this.log(`Loaded video template for slide ${t}`);
        }
        const a = r.querySelector("video"),
            l = r.querySelector("iframe");
        if ((a ? ((e.video = a), (e.iframe = null)) : l && ((e.iframe = l), (e.video = null)), e.video))
            try {
                (e.video.muted = !0),
                    (e.video.currentTime = 0),
                    await new Promise((d) => {
                        if (e.video.readyState >= 3) d();
                        else {
                            const u = () => {
                                e.video.removeEventListener("canplay", u), d();
                            };
                            e.video.addEventListener("canplay", u);
                        }
                    }),
                    await e.video.play();
                const c = r.querySelector("img, .placeholder");
                c && c instanceof HTMLElement && (c.style.display = "none"), this.log(`Playing video ${t}`);
            } catch {
                this.log(`Failed to play video ${t}`, "error"), this.startImageAutoplay();
            }
        else
            e.iframe
                ? this.startImageAutoplay()
                : (this.log(`No video element found for slide ${t}`, "warn"), this.startImageAutoplay());
    }
    handleVideoClick(t) {
        if (t !== this.currentIndex) return;
        const e = this.slides[t];
        if (!e || e.type !== "video") return;
        const i = e.slide.querySelectorAll(".hero-slider__video-container"),
            n = Array.from(i).find((o) => window.getComputedStyle(o).display !== "none");
        if (!n) return;
        const r = n.querySelector("video");
        r && (r.paused ? r.play() : r.pause());
    }
    handleVideoEnded(t) {
        t === this.currentIndex &&
            (this.log(`Video ${t} ended, advancing to next slide`),
            window.setTimeout(() => {
                this.nextSlide();
            }, 500));
    }
    pauseCurrentVideo() {
        const t = this.slides[this.currentIndex];
        t?.video && !t.video.paused && t.video.pause();
    }
    pauseAllVideos() {
        this.slides.forEach((t) => {
            t.video && !t.video.paused && t.video.pause();
        });
    }
    startAutoplay() {
        if (!this.config.autoplay) return;
        this.slides[this.currentIndex]?.type === "image" && this.startImageAutoplay();
    }
    startImageAutoplay() {
        this.config.autoplay &&
            (this.clearAutoplayTimer(),
            (this.autoplayTimer = window.setTimeout(() => {
                this.nextSlide();
            }, this.config.autoplayDelay)));
    }
    clearAutoplayTimer() {
        this.autoplayTimer !== null && (window.clearTimeout(this.autoplayTimer), (this.autoplayTimer = null));
    }
    pauseAutoplay() {
        this.clearAutoplayTimer();
    }
    resumeAutoplay() {
        if (document.hidden) return;
        this.slides[this.currentIndex]?.type === "image" && this.startImageAutoplay();
    }
    nextSlide() {
        if (this.isTransitioning) return;
        this.pauseAllVideos();
        let t = this.currentIndex + 1;
        if (t >= this.slides.length)
            if (this.config.loop) t = 0;
            else return;
        this.showSlide(t);
    }
    prevSlide() {
        if (this.isTransitioning) return;
        this.pauseAllVideos();
        let t = this.currentIndex - 1;
        if (t < 0)
            if (this.config.loop) t = this.slides.length - 1;
            else return;
        this.showSlide(t);
    }
    getValidIndex(t) {
        return t < 0
            ? this.config.loop
                ? this.slides.length - 1
                : 0
            : t >= this.slides.length
              ? this.config.loop
                  ? 0
                  : this.slides.length - 1
              : t;
    }
    updateNavigationState() {
        this.config.loop ||
            (this.elements.nextButton &&
                this.elements.nextButton.classList.toggle("is-disabled", this.currentIndex === this.slides.length - 1));
    }
    selectBlock(t) {
        const e = this.slides.findIndex(({ slide: i }) => i.dataset.blockId === t);
        e !== -1 && (this.pauseAutoplay(), this.showSlide(e));
    }
    deselectBlock(t) {
        this.resumeAutoplay();
    }
    destroy() {
        this.isDestroyed() ||
            (this.clearAutoplayTimer(),
            this.pauseCurrentVideo(),
            this.abortController && (this.abortController.abort(), (this.abortController = null)),
            super.destroy(),
            this.log("Hero slider destroyed"));
    }
}
const P = {
        onBlockSelect: (s, t, e) => {
            e?.selectBlock?.(t);
        },
        onBlockDeselect: (s, t, e) => {
            e?.deselectBlock?.(t);
        },
    },
    Ne = {
        collage: () => ({
            onLoad: (s) => {
                const t = s.dataset.mobileCarousel === "true",
                    e = s.querySelector(".collage__slide-container");
                return t && e ? new Lt(s, { mobileCarousel: !0, mobileContentHover: !1 }) : null;
            },
            onUnload: (s, t) => t?.destroy?.(),
        }),
        "main-product": () => ({
            onLoad: (s) =>
                new Dt(s, { productId: s.dataset.productId || "", sectionId: s.dataset.sectionId || "", debug: !0 }),
            onUnload: (s, t) => t?.destroy?.(),
            ...P,
        }),
        "benefits-cards": () => ({ onLoad: (s) => new qt(s), onUnload: (s, t) => t?.destroy?.(), ...P }),
        "featured-collection-enhanced": () => ({ onLoad: (s) => new Be(s), onUnload: (s, t) => t?.destroy?.() }),
        "testimonial-carousel": () => ({ onLoad: (s) => new Ve(s), onUnload: (s, t) => t?.destroy?.(), ...P }),
        "explore-tabs": () => ({ onLoad: (s) => new qe(s), onUnload: (s, t) => t?.destroy?.(), ...P }),
        "hero-slider": () => ({ onLoad: (s) => new $e(s), onUnload: (s, t) => t?.destroy?.(), ...P }),
    },
    ze = "200px";
function Fe(s, t) {
    const e = () => document.querySelectorAll(`[data-section-type="${s}"]`),
        i = new Map(),
        n = new WeakSet(),
        r = (l) => {
            if (l.parentElement?.closest(`[data-section-type="${s}"]`) || i.has(l)) return;
            const d = t.onLoad(l);
            d && (i.set(l, d), h(`[LazyInit] ${s} initialized`, "info"));
        },
        o = new IntersectionObserver(
            (l) => {
                l.forEach((c) => {
                    if (c.isIntersecting) {
                        const d = c.target;
                        r(d), o.unobserve(d);
                    }
                });
            },
            { rootMargin: ze }
        ),
        a = () => {
            e().forEach((l) => {
                n.has(l) || (n.add(l), s === "hero-slider" ? r(l) : o.observe(l));
            });
        };
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", a, { once: !0 }) : a(),
        document.addEventListener("shopify:section:load", (l) => {
            const c = l.target?.querySelector?.(`[data-section-type="${s}"]`);
            c && (o.unobserve(c), r(c));
        }),
        document.addEventListener("shopify:section:unload", (l) => {
            const c = l.target?.querySelector?.(`[data-section-type="${s}"]`);
            if (c) {
                o.unobserve(c);
                const d = i.get(c);
                t.onUnload?.(c, d), i.delete(c);
            }
        }),
        document.addEventListener("shopify:section:select", (l) => {
            const c = l.target;
            t.onSelect?.(c, i.get(c));
        }),
        document.addEventListener("shopify:section:deselect", (l) => {
            const c = l.target;
            t.onDeselect?.(c, i.get(c));
        }),
        document.addEventListener("shopify:block:select", (l) => {
            const c = l,
                d = c.target.closest(`[data-section-type="${s}"]`);
            if (d) {
                i.has(d) || (o.unobserve(d), r(d));
                const u = c.detail?.blockId || c.target.dataset?.blockId || "";
                t.onBlockSelect?.(d, u, i.get(d));
            }
        }),
        document.addEventListener("shopify:block:deselect", (l) => {
            const c = l,
                d = c.target.closest(`[data-section-type="${s}"]`);
            if (d) {
                const u = c.detail?.blockId || c.target.dataset?.blockId || "";
                t.onBlockDeselect?.(d, u, i.get(d));
            }
        });
}
function Ke() {
    h("Registering section lifecycles", "info");
    const s = new Set(
        Array.from(document.querySelectorAll("[data-section-type]"))
            .map((t) => t.dataset.sectionType)
            .filter(Boolean)
    );
    s.forEach((t) => {
        const e = Ne[t];
        if (e)
            try {
                Fe(t, e());
            } catch (i) {
                h(`Failed to load section module: ${t}`, "error", i);
            }
    }),
        h(`Registered ${s.size} section lifecycles`, "info");
}
export { We as a, Ke as b, h as c, Ue as i, vt as o, je as r };
